export default {
  welcome: 'Chào mừng',
  hi: 'Xin chào',

  base: {
    here: 'tại đây',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    default: 'Mặc định',
    created_at: 'Tạo lúc',
    status: 'Trạng thái',
    proxy: 'Proxy',
    proxy_status: 'Trạng thái Proxy',
    config_proxy: 'Cấu hình proxy',
    link_shop: 'Liên kết tài khoản',
    linked_shop: 'Đã liên kết tài khoản',
    optional: 'Tùy chọn',
    action: 'Hành động',
    actions: 'Hành động',
    good: 'Tốt',
    error: 'Lỗi',
    connect_platform: 'Kết nối với các nền tảng',
    active: 'Đang hoạt động',
    deactivate: 'Ngưng hoạt động',
    open: 'Mở',
    close: 'Đóng',
    confirm: 'Xác nhận',
    reject: 'Từ chối',
    accept: 'Chấp nhận',
    otp_code: 'Mã OTP',
    save_config: 'Lưu cấu hình',
    delete_config: 'Xóa cấu hình',
    edit_config: 'Chỉnh sửa cấu hình',
    edit_x_config: 'Chỉnh sửa cấu hình {x}',
    mass_save_config: 'Lưu cấu hình hàng loạt',
    delete_mass_config: 'Xóa cấu hình hàng loạt',
    mass_edit_config: 'Chỉnh sửa cấu hình hàng loạt',
    mass_edit_x_config: 'Chỉnh sửa cấu hình {x} hàng loạt',
    save_file: 'Lưu file',
    save_x_file: 'Lưu file {x}',
    delete_file: 'Xóa file',
    mass_delete_file: 'Xóa file hàng loạt',
    has_an_occurred: 'Đã có lỗi xảy ra',
    save_config_success: 'Lưu cấu hình thành công',
    connect_config_success: 'Kết nối cấu hình thành công',
    connect_config_error: 'Kết nối cấu hình thất bại',
    has_error: 'Đã xảy ra lỗi',
    invalid_file_format: 'Định dạng file không hợp lệ',
    cancel: 'Hủy',
    attention: 'Chú ý',
    confirm_delete_x: 'Bạn có chắc muốn xóa {x} không?',
    delete_x_success: 'Xóa {x} thành công',
    save_x_success: 'Lưu {x} thành công',
    edit_x_success: 'Chỉnh sửa {x} thành công',
    create: 'Tạo',
    create_new: 'Tạo mới',
    edit: 'Chỉnh sửa',
    update: 'Cập nhật',
    delete: 'Xóa',
    profile: 'Thông tin tài khoản',
    change_password: 'Đổi mật khẩu',
    change_password_note: 'Đổi mật khẩu sẽ yêu cầu đăng nhập lại tài khoản.',
    balance: 'Số dư',
    pack: 'Gói',
    display_name: 'Tên hiển thị',
    phone_number: 'Số điện thoại',
    current_password: 'Mật khẩu hiện tại',
    new_password: 'Mật khẩu mới',
    confirm_password: 'Xác nhận mật khẩu',
    confirmed: 'Đã xác nhận',
    rejected: 'Đã từ chối',
    receiver: 'Người nhận',
    send_at: 'Gửi lúc',
    state: 'Trạng thái',
    pending: 'Đang chờ',
    pending_confirm: 'Chờ xác nhận',
    sent: 'Đã gửi',
    channel: 'Kênh',
    select_all: 'Chọn tất cả',
    confirm_action: 'Bạn có chắc muốn thực hiện hành động này không?',
    config: 'Cấu hình',
    keyword: 'Từ khóa',
    keywords: 'Từ khóa',
    select_top_x_y: 'Chọn top {x} {y} đầu tiên',
    unselect_all_x: 'Bỏ chọn tất cả {x}',
    download_excel: 'Tải file Excel',
    export_excel: 'Xuất file Excel',
    add_selected_x: 'Thêm {x} đã chọn',
    delete_selected_x: 'Xóa {x} đã chọn',
    import_from_excel: 'Nhập từ file Excel',
    delete_all_x: 'Xóa tất cả {x}',
    filename: 'Tên file',
    volume: 'Lượt tìm kiếm',
    recommend_price: 'Giá đề xuất',
    your_price: 'Giá của bạn',
    x_selected: '{x} đã chọn',
    add: 'Thêm',
    at: 'lúc',
    error_reading_file: 'Đã có lỗi xảy ra khi đọc file',
    create_at_least_product: 'Quý khách vui lòng đăng ít nhất 1 sản phẩm để sử dụng tính năng này!',
    filter: 'Bộ lọc',
    compare_data: 'Đối chiếu dữ liệu',
    expanded_search: 'Tìm kiếm mở rộng',
    exact_search: 'Tìm kiếm chính xác',
    relevance: 'Chất lượng từ khóa',
    shopee_volume: 'Lượt tìm kiếm Shopee',
    column: 'Tên cột',
    expression: 'Biểu thức',
    value: 'Giá trị',
    delete_filter: 'Xóa bộ lọc',
    execute: 'Thực hiện',
    shopee_price: 'Giá thầu Shopee',
    mobile: 'Điện thoại',
    desktop: 'Máy tính',
    total: 'Tổng',
    start_time: 'Thời gian bắt đầu',
    end_time: 'Thời gian kết thúc',
    product: 'Sản phẩm',
    settings: 'Thiết lập',
    on: 'Đang bật',
    off: 'Đang tắt',
    turn_on: 'Bật',
    turn_off: 'Tắt',
    select_plan_file: 'Chọn file kế hoạch',
    export_data: 'Tải dữ liệu',
    campaign: 'Chiến dịch',
    campaign_detail: 'Chi tiết chiến dịch',
    select: 'Chọn',
    x_on_current_page: '{x} trên trang hiện tại',
    reload: 'Tải lại',
    reload_data: 'Tải lại dữ liệu',
    basic: 'Cơ bản',
    base: 'Cơ bản',
    applying: 'Đang áp dụng',
    applying_x: 'Đang áp dụng {x}',
    not_applying_x: 'Chưa áp dụng {x}',
    ongoing: 'Đang chạy',
    paused: 'Tạm dừng',
    ended: 'Đã kết thúc',
    deleted: 'Đã xóa',
    out_stock: 'Hết hàng',
    from: 'Từ',
    to: 'Đến',
    no_end_date: 'Không giới hạn',
    unselect: 'Bỏ chọn',
    budget: 'Ngân sách',
    low_budget: 'Ngân sách thấp',
    unlimited: 'Không giới hạn',
    daily_budget: 'Ngân sách ngày',
    total_budget: 'Tổng ngân sách',
    select_tags: 'Chọn thẻ',
    add_tags: 'Gắn thẻ',
    remove_tags: 'Xóa thẻ',
    type: 'Loại',
    tags_added: 'Đã gắn thẻ',
    no_tags_added: 'Chưa gắn thẻ',
    create_tags: 'Tạo thẻ',
    update_tags: 'Cập nhật thẻ',
    delete_tags: 'Xóa thẻ',
    add_tags_for_selected_x: 'Gắn thẻ cho {x} đã chọn',
    remove_tags_of_selected_x: 'Xóa thẻ của {x} đã chọn',
    pause: 'Tạm dừng',
    resume: 'Tiếp tục',
    end: 'Kết thúc',
    stop: 'Dừng',
    setup_x: 'Cài đặt {x}',
    restart: 'Bắt đầu lại',
    all: 'Tất cả',
    clone_x: 'Nhân bản {x}',
    copy_x: 'Sao chép {x}',
    calculate_from: 'Tính từ',
    shopee_recommend_price: 'Giá đề xuất Shopee',
    current_price: 'Giá hiện tại',
    i_or_d: 'Tăng hoặc giảm',
    increase: 'Tăng',
    decrease: 'Giảm',
    percent: 'Phần trăm',
    amount: 'Số tiền',
    apply: 'Áp dụng',
    i_or_d_type: 'Kiểu tăng / giảm',
    select_start_time: 'Chọn thời gian bắt đầu',
    select_end_time: 'Chọn thời gian kết thúc',
    set_budget: 'Thiết lập ngân sách',
    set_budget_by_cost_percent: 'Điều chỉnh ngân sách theo % chi phí',
    getting_data: 'Đang lấy dữ liệu',
    loading_data: 'Đang tải dữ liệu',
    selected: 'Đã chọn',
    category: 'Ngành hàng',
    shop_category: 'Danh mục của shop',
    show_eligible_products_only: 'Xem sản phẩm có sẵn',
    image: 'Ảnh',
    monthly_sales: 'Bán mỗi tháng',
    monthly_gmv: 'Doanh thu tháng',
    revenue: 'Doanh thu',
    sales: 'Doanh thu',
    price: 'Giá',
    stock: 'Kho',
    configuration_setup_guide: 'Hướng dẫn cài đặt cấu hình',
    minimum: 'tối thiểu',
    maximum: 'tối đa',
    not_required: 'Không bắt buộc',
    select_duration: 'Chọn khoảng thời gian kiểm tra',
    today: 'Ngày hôm nay',
    yesterday: 'Ngày hôm qua',
    last_week: 'Tuần vừa qua',
    last_month: 'Tháng vừa qua',
    date_range: 'Từ ngày - đến ngày',
    save_configuration: 'Lưu cấu hình',
    display_by_selected_metrics: 'Hiển thị theo chỉ số đã chọn',
    save_filter: 'Lưu bộ lọc',
    use_saved_filter: 'Sử dụng bộ lọc đã lưu',
    mass_edit_x: 'Chỉnh sửa {x} hàng loạt',
    i_or_d_x_by_amount: 'Tăng / giảm {x} theo số tiền',
    i_or_d_x_by_percent: 'Tăng / giảm {x} theo phần trăm',
    budget_type: 'Kiểu ngân sách',
    select_budget_type: 'Chọn kiểu ngân sách',
    set_x: 'Thiết lập {x}',
    set_x_by_y: 'Thiết lập {x} theo {y}',
    bid_price: 'Giá đấu thầu',
    use_recommend_price: 'Sử dụng giá thầu gợi ý',
    use_cpc: 'Sử dụng CPC',
    select_cpc_duration: 'Chọn thời gian áp dụng CPC',
    set_bid_price: 'Điều chỉnh giá đấu thầu',
    higher: 'Cao hơn',
    lower: 'Thấp hơn',
    configuration_runtime_list: 'Danh sách thời gian chạy',
    starting_at: 'Bắt đầu từ',
    ending_at: 'Kết thúc vào',
    starting_time: 'Bắt đầu từ',
    ending_time: 'Kết thúc vào',
    select_all_day: 'Chọn cả ngày',
    set_when_outside_runtime: 'Điều chỉnh khi thời gian không nằm trong Khung giờ cài đặt',
    keep_bid_price: 'Duy trì giá thầu',
    pause_keyword: 'Tạm dừng từ khóa',
    resume_keyword: 'Bật từ khóa',
    delete_keyword: 'Xóa từ khóa',
    set_amount: 'Cài đặt số tiền',
    max_bid_price: 'Giá thầu tối đa',
    advanced_max_bid_price: 'Giá thầu tối đa nâng cao',
    min_bid_price: 'Giá thầu tối thiểu',
    bonus_amount: 'Số tiền cộng thêm',
    deduction_amount: 'Số tiền trừ đi',
    from_current_bid_price: 'với giá thầu hiện tại',
    of_current_bid_price: 'của giá thầu hiện tại',
    current_duration: 'Khung giờ hiện tại',
    expected_cir: 'Tỉ lệ CIR (ACOS) mong muốn',
    expected_roas: 'Tỉ lệ ROI (ROAS) mong muốn',
    expected_exclude_cancelled_roi: 'Tỉ lệ ROI (ROAS) đã trừ huỷ mong muốn',
    expected_roi: 'Chỉ số ROI (ROAS) mong muốn',
    starting_bid_price: 'Giá thầu khởi điểm',
    from_date: 'Từ ngày',
    to_date: 'Đến ngày',
    disable_compare_data: 'Tắt đối chiếu',
    set_by_x: 'Điều chỉnh theo {x}',
    edit_by_x: 'Chỉnh sửa theo {x}',
    starting_budget: 'Ngân sách đầu ngày (Khung 0h00p)',
    not_recommended: 'Không khuyến nghị',
    edit_bid_price: 'Chỉnh sửa giá thầu',
    added: 'Đã thêm',
    add_config: 'Thêm cấu hình',
    configuration_list: 'Danh sách cấu hình',
    search: 'Tìm kiếm',
    action_plan: 'Hành động xử lý',
    increase_type: 'Kiểu tăng',
    decrease_type: 'Kiểu giảm',
    increase_by_amount: 'Tăng theo số tiền',
    increase_by_percent: 'Tăng theo phần trăm',
    decrease_by_amount: 'Giảm theo số tiền',
    decrease_by_percent: 'Giảm theo phần trăm',
    max_cost: 'Chi phí tối đa',
    applied_keyword_type: 'Loại từ khóa áp dụng',
    conditions_for_applying: 'Điều kiện áp dụng',
    automatic_i_or_d: 'Tự động tăng / giảm',
    i_or_d_by_amount: 'Tăng / giảm theo số tiền',
    i_or_d_by_percent: 'Tăng / giảm theo phần trăm',
    update_to_starting_bid_price: 'Cập nhật về giá thầu khởi điểm',
    automatic: 'Tự động',
    by_amount: 'Theo số tiền',
    by_percent: 'Theo phần trăm',
    update_keyword_by_conditions: 'Cập nhật từ khóa theo điều kiện',
    condition: 'Điều kiện',
    conditions: 'Điều kiện',
    add_condition: 'Thêm điều kiện',
    increase_amount: 'Tăng số tiền',
    increase_bid_price: 'Tăng giá thầu',
    decrease_amount: 'Giảm số tiền',
    decrease_bid_price: 'Giảm giá thầu',
    set_by_cpc: 'Điều chỉnh giá thầu theo CPC',
    change_to_exact: 'Chuyển sang từ khóa chính xác',
    change_to_broad: 'Chuyển sang từ khóa mở rộng',
    conditions_and_actions: 'Điều kiện & hành động',
    add_conditions_actions: 'Thêm điều kiện & hành động',
    use_file: 'Sử dụng file',
    saved_files: 'File đã lưu',
    use: 'Sử dụng',
    create_new_file: 'Tạo file mới',
    update_existed_file: 'Cập nhật file đã lưu',
    update_campaign_status: 'Cập nhật trạng thái chiến dịch',
    update_campaign_status_message: 'Lựa chọn này chỉ áp dụng đối với các chiến dịch đang ở trạng thái dừng hẳn.',
    pause_ads: 'Tạm dừng quảng cáo',
    daily_discover: 'Gợi ý hôm nay',
    you_may_also_like: 'Có thể bạn cũng thích',
    mass_resume_configuration: 'Bật cấu hình hàng loạt',
    mass_pause_configuration: 'Tạm dừng cấu hình hàng loạt',
    mass_delete_configuration: 'Xóa cấu hình hàng loạt',
    conditions_actions_template: 'Mẫu điều kiện & hành động',
    create_manual_rules: 'Tạo quy tắc thủ công',
    auto_position_and_optimize_cir_template: 'Mẫu quy tắc Duy trì vị trí + Tối ưu CIR',
    auto_budget_template: 'Mẫu quy tắc Tối ưu ngân sách theo CIR',
    conditions_groups: 'Nhóm điều kiện',
    conditions_group: 'Nhóm điều kiện',
    level: 'Cấp độ',
    audience: 'Đối tượng',
    include_tags: 'Có chứa thẻ',
    cost_and_budget_rate: 'Tỉ lệ chi phí / ngân sách',
    and: 'Và',
    or: 'Hoặc',
    add_x: 'Thêm {x}',
    do_nothing: 'Không tác động',
    increase_budget: 'Tăng ngân sách',
    decrease_budget: 'Giảm ngân sách',
    resume_campaign: 'Bật chiến dịch',
    pause_campaign: 'Tạm dừng chiến dịch',
    clone_campaign: 'Nhân bản chiến dịch',
    set_budget_by_realtime_cost: 'Điều chỉnh ngân sách bằng chi phí ngày',
    increase_budget_from_realtime_cost: 'Tăng ngân sách từ chi phí ngày theo số tiền',
    max_budget: 'Ngân sách tối đa',
    min_budget: 'Ngân sách tối thiểu',
    resume_ad: 'Bật quảng cáo',
    pause_ad: 'Tạm dừng quảng cáo',
    note: 'Ghi chú',
    setup_operation_rules: 'Cài đặt quy tắc hoạt động',
    config_name: 'Tên cấu hình',
    update_config_file: 'Cập nhật file cấu hình',
    applying_config_list: 'Danh sách cấu hình đang áp dụng',
    saved_config_list: 'Danh sách cấu hình đã lưu',
    installed_config_list: 'Danh sách cấu hình đã cài đặt',
    automatic_by_condition_configuration_list: 'Danh sách cấu hình tự động theo điều kiện',
    continuously: 'Liên tục',
    once_a_day: 'Một lần',
    condition_action_number: 'Số điều kiện & hành động',
    only_show_me: 'Chỉ mình tôi nhìn thấy cấu hình này',
    view_activity_history: 'Xem lịch sử hoạt động',
    config_file: 'File cấu hình',
    share: 'Chia sẻ',
    convert_automatic_config_to_automatic_condition: 'Chuyển cấu hình tự động sang cấu hình theo điều kiện',
    manage_tags: 'Quản lý thẻ phân loại',
    filter_name: 'Tên bộ lọc',
    saved_filter_list: 'Danh sách bộ lọc đã lưu',
    config_file_name: 'Tên file cấu hình',
    config_code: 'Mã cấu hình',
    error_code: 'Mã lỗi',
    time: 'Thời gian',
    targeting: 'Khám phá',
    copy: 'Sao chép',
    use_starting_bid_price: 'Sử dụng giá thầu khởi điểm',
    import_config_success: 'Import cấu hình thành công',
    config_not_found: 'Không tìm thấy cấu hình',
    update_file_confirm: 'Bạn có chắc chắn muốn cập nhật file này không?',
    delete_file_confirm: 'Bạn có chắc chắn muốn xóa file này không?',
    update_success: 'Cập nhật thành công',
    save_success: 'Lưu thành công',
    delete_success: 'Xóa thành công',
    edit_success: 'Chỉnh sửa thành công',
    clone_confirm: 'Bạn có chắc chắn muốn nhân bản chiến dịch này không?',
    delete_filter_confirm: 'Bạn có chắc chắn muốn xóa bộ lọc không không?',
    delete_tags_confirm: 'Bạn có chắc chắn muốn xóa thẻ không không?',
    use_condition_template_message: 'Bạn có chắc chắn muốn sử dụng mẫu cấu hình này không? Lưu ý, các cài đặt hiện tại sẽ bị thay thế.',
    convert_to_condition_message: 'Bạn có chắc chắn muốn thay đổi sang cấu hình theo điều kiện không? Lưu ý, các cấu hình cũ sẽ bị tạm dừng.',
    delete_config_confirm: 'Bạn có chắc chắn muốn xóa cấu hình này không?',
    delete_config_success: 'Xoá cấu hình thành công',
    delete_multiple_config_confirm: 'Bạn có chắc chắn muốn xóa các cấu hình này không?',
    save_config_confirm: 'Bạn có chắc chắn muốn lưu cấu hình này không?',
    invalid_data: 'Dữ liệu không hợp lệ',
    update_config_status_confirm: 'Bạn có chắc chắn muốn thay đổi trạng thái của cấu hình không?',
    y_gte_than_x: '{y} phải lớn hơn hoặc bằng {x}',
    y_gt_than_x: '{y} phải lớn hơn {x}',
    y_lte_than_x: '{y} phải nhỏ hơn hoặc bằng {x}',
    y_lt_than_x: '{y} phải nhỏ hơn {x}',
    y_eq_x: '{y} phải bằng {x}',
    y_ne_x: '{y} khác {x}',
    y_gte_x: '{y} phải lớn hơn hoặc bằng {x}',
    y_gt_x: '{y} phải lớn hơn {x}',
    y_lte_x: '{y} phải nhỏ hơn hoặc bằng {x}',
    y_lt_x: '{y} phải nhỏ hơn {x}',
    update_data_confirm: 'Bạn có chắc chắn muốn cập nhật dữ liệu không?',
    update_data_success: 'Cập nhật dữ liệu thành công',
    need_up_to_pro_package: 'Bạn cần nâng cấp lên gói PRO hoặc cao hơn để sử dụng tính năng này.',
    update_keywords_success: 'Cập nhật từ khóa thành công',
    runtime_is_used: 'Thời gian chạy đã được sử dụng. Vui lòng sử dụng ngày hoạt động khác.',
    update_keyword_by_cir_confirm: 'Bạn có chắc chắn muốn cập nhật từ khóa theo CIR không?',
    add_keywords_confirm: 'Bạn có chắc chắn muốn thêm các từ khóa vào chiến dịch không?',
    keywords_result_not_found: 'Không tìm thấy kết quả cho từ khóa',
    update_bid_price_confirm: 'Bạn có chắc chắn muốn cập nhật giá thầu không?',
    hours: 'giờ',
    minutes: 'phút',
    the_next_day: 'ngày hôm sau',
    create_campaign_confirm: 'Bạn có chắc chắn muốn tạo chiến dịch quảng cáo này không?',
    create_campaign_success: 'Tạo chiến dịch mới thành công',
    max_clicks: 'Số lượt click tối đa',
    min_clicks: 'Số lượt click tối thiểu',
    ratio: 'Tỉ lệ',
    back: 'Quay lại',
    create_new_campaign: 'Tạo chiến dịch mới',
    basic_settings: 'Thiết lập cơ bản',
    products: 'Sản phẩm',
    campaign_name: 'Tên chiến dịch',
    ad_name: 'Tên quảng cáo',
    tagline: 'Khẩu hiệu',
    set_start_end_date: 'Thiết lập ngày bắt đầu/kết thúc',
    set_start_end_time: 'Thiết lập thời gian bắt đầu/kết thúc',
    set_start_end_hour: 'Thiết lập giờ bắt đầu/kết thúc',
    bidding: 'Đặt giá thầu',
    optional_bidding: 'Tùy chỉnh giá thầu theo mong muốn của bạn.',
    manual_bidding: 'Giá thầu thủ công',
    keyword_selection: 'Lua chọn từ khóa',
    shopee_recommend: 'Shopee đề xuất',
    search_keywords: 'Tìm kiếm từ khóa',
    use_saved_bid_price: 'Sử dụng giá thầu đã lưu',
    use_shopee_bid_price: 'Sử dụng giá thầu Shopee',
    saved_bid_price: 'Giá thầu đã lưu',
    shopee_bid_price: 'Giá thầu Shopee',
    remove_duplicated_keywords: 'Loại bỏ các từ khóa bị trùng',
    duration: 'Thời gian',
    discovery: 'Khám phá',
    select_products: 'Chọn sản phẩm',
    manually_select_products: 'Chọn sản phẩm thủ công',
    choose_specific_products_message: 'Chọn sản phẩm cụ thể để chạy Quảng cáo dựa theo mục tiêu của bạn.',
    add_products: 'Thêm sản phẩm',
    add_recommend_products: 'Thêm sản phẩm theo gợi ý',
    code: 'Mã',
    id: 'Mã',
    ratings: 'Lượt đánh giá',
    see_detail: 'Xem chi tiết',
    running_ads: 'Đang chạy quảng cáo',
    let_shopee_do: 'Shopee sẽ tối ưu hóa việc hiển thị quảng cáo của bạn cho người mua sắm, giúp bạn đạt hiệu quả cao nhất.',
    bidding_settings_manually: 'Tùy chỉnh giá thầu theo mong muốn của bạn.',
    target_roas: 'Mục tiêu ROAS',
    set_your_own_roas: 'Tự thiết lập mục tiêu ROAS',
    discovery_locations: 'Cài đặt vị trí khám phá',
    audience_targeting: 'Đối tượng',
    auto_targeting: 'Tự động',
    manual_targeting: 'Thủ công',
    custom_audience: 'Đối tượng tùy chỉnh',
    new_custom_audience: 'Đối tượng tùy chỉnh',
    age: 'Tuổi',
    gender: 'Giới tính',
    buyer_type: 'Tệp khách hàng',
    premium_rate: 'Mức premium (%)',
    all_products: 'Tất cả sản phẩm',
    not_creating_ads: 'Chưa tạo quảng cáo',
    men: 'Nam',
    women: 'Nữ',
    potential_new_buyers: 'Khách hàng tiềm năng mới',
    sold: 'Đã bán',
    product_campaign_detail: 'Chi tiết quảng cáo Sản phẩm',
    product_manual_campaign_detail: 'Chi tiết quảng cáo Sản phẩm',
    product_auto_campaign_detail: 'Chi tiết quảng cáo Sản phẩm',
    live_stream_campaign_detail: 'Chi tiết quảng cáo Live Stream',
    shop_campaign_detail: 'Chi tiết quảng cáo Shop',
    placement: 'Vị trí hiển thị',
    shopee_advanced_settings: 'Cài đặt nâng cao Shopee',
    shopee_advanced_settings_note: 'Khi Giá thầu Cạnh tranh được bật, giá thầu thực tế của bạn cho mỗi lượt nhấp chuột sẽ được tối ưu hóa dựa trên khả năng chuyển đổi: tăng khi có cơ hội ra đơn cao và giảm khi có cơ hội ra đơn thấp. Hệ thống sẽ đảm bảo rằng giá thầu trung bình mỗi ngày cho mỗi nhấp chuột sẽ sát với mức giá thầu mà bạn đã đặt.',
    turning_on: 'Đang bật',
    turning_off: 'Đang tắt',
    mass_edit_bid_price: 'Chỉnh sửa giá thầu hàng loạt',
    mass_update_keywords: 'Cập nhật từ khóa hàng loạt',
    update_keywords_by_conditions: 'Cập nhật từ khóa theo điều kiện',
    change_keywords_type: 'Thay đổi loại từ khóa',
    change_keywords_status: 'Thay đổi trạng thái từ khóa',
    mass_change_keywords_type: 'Thay đổi loại từ khóa hàng loạt',
    mass_change_keywords_status: 'Thay đổi trạng thái từ khóa hàng loạt',
    mass_delete_keywords: 'Xóa từ khóa hàng loạt',
    delete_keywords: 'Xóa từ khóa',
    advanced: 'Nâng cao',
    other_options: 'Tùy chọn khác',
    download_x_file: 'Tải file {x}',
    selected_keywords: 'Từ khóa đã chọn',
    shopee_report: 'Báo cáo Shopee',
    auto_bidding: 'Quảng cáo tự động',
    restore: 'Khôi phục',
    installed: 'Đã cài đặt',
    not_installed: 'Chưa cài đặt',
    update_bid_price: 'Cập nhật giá thầu',
    edit_target_roas: 'Chỉnh sửa mục tiêu ROAS',
    edit_audience: 'Chỉnh sửa đối tượng',
    audience_name: 'Tên đối tượng',
    bonus_premium_rate: 'Mức premium cộng thêm',
    max_premium_rate: 'Mức premium tối đa',
    reduction_premium_rate: 'Mức premium trừ đi',
    min_premium_rate: 'Mức premium tối thiểu',
    enhanced_bid_price: 'Giá thầu cạnh tranh',
    change_placement_confirm: 'Bạn có chắc chắn muốn thay đổi vị trí hiển thị của quảng cáo không?',
    precomposed: 'Dựng sẵn',
    combining: 'Tổ hợp',
    cannot_export_report: 'Không thể tải báo cáo',
    delete_campaign_confirm: 'Bạn có muốn xóa chiến dịch này không? Quảng cáo đã xoá không thể khôi phục! Bạn vẫn có thể xem dữ liệu của quảng cáo đã xóa trong 2 tuần, sau đó chúng sẽ bị xóa vĩnh viễn khỏi hệ thống.',
    edit_campaign: 'Chỉnh sửa chiến dịch',
    shop_page: 'Trang chủ shop',
    add_keyword_success: 'Thêm từ khóa thành công',
    min: 'Tối thiểu',
    bid_price_per_click: 'Giá thầu mỗi click',
    setup: 'Cài đặt',
    exact: 'Chính xác',
    broad: 'Mở rộng',
    update_campaign: 'Cập nhật chiến dịch',
    edit_image: 'Chỉnh sửa ảnh',
    all_data: 'Tất cả dữ liệu',
    discovery_placement: 'Vị trí khám phá',
    all_placements: 'Tất cả vị trí',
    lookup: 'Tra cứu',
    created_time: 'Thời gian tạo',
    timestamp: 'Thời gian',
    old_data: 'Dữ liệu cũ',
    new_data: 'Dữ liệu mới',
    view_data_detail: 'Xem chi tiết dữ liệu',
    analyze: 'Phân tích',
    analyze_data: 'Phân tích dữ liệu',
    upload_report: 'Upload file báo cáo',
    search_query: 'Lệnh tìm kiếm',
    query: 'Truy vấn',
    search_query_volume: 'Lượt tìm kiếm lệnh tìm kiếm',
    past1week: '1 tuần qua',
    past1month: '1 tháng qua',
    past3months: '3 tháng qua',
    since_begin_week: 'Từ đầu tuần',
    since_begin_month: 'Từ đầu tháng',
    ads_metrics: 'Chỉ số quảng cáo',
    overview_metrics: 'Chỉ số toàn shop',
    chart: 'Biểu đồ',
    sales_metrics: 'Chỉ số bán hàng',
    buyer_info: 'Thông tin nguời mua',
    total_buyers: 'Tổng số người mua',
    new_buyers: 'Số người mua mới',
    followers: 'Số người theo dõi',
    existing_buyers: 'Số người mua lại',
    repeat_purchase_rate: 'Tỉ lệ mua lặp lại',
    funnel_sales: 'Doanh số phễu',
    previous_day: 'Ngày hôm trước',
    buyers: 'Người mua',
    basic_info: 'Thông tin cơ bản',
    products_info: 'Thông tin sản phẩm',
    update_products: 'Cập nhật sản phẩm',
    change_product_name_confirm: 'Bạn có chắc chắn muốn đổi tên sản phẩm không?',
    update_product_name_success: 'Đổi tên sản phẩm thành công',
    data: 'Dữ liệu',
    month: 'Tháng',
    year: 'Năm',
    sku: 'SKU',
    model: 'Phân loại',
    variations: 'Phân loại',
    variation_list: 'Dan sách phân loại',
    variation_name: 'Tên phân loại',
    period: 'Thời gian',
    loading_products: 'Đang tải danh sách sản phẩm',
    mass_setup: 'Cài đặt hàng loạt',
    info: 'Thông tin',
    old_name: 'Tên cũ',
    new_name: 'Tên mới',
    length: 'Độ dài',
    result: 'Kết quả',
    preview: 'Xem trước',
    updated_at: 'Cập nhật lúc',
    download: 'Tải',
    frame: 'khung',
    frame_image: 'Khung ảnh',
    cannot_upload_file: 'Không thể upload file',
    add_success: 'Thêm thành công',
    created_by: 'Người tạo',
    upcoming: 'Sắp diễn ra',
    expired: 'Đã kết thúc',
    time_slot: 'Khung giờ',
    time_slots: 'Khung giờ',
    copy_data: 'Sao chép dữ liệu',
    shop: 'Cửa hàng',
    update_file: 'Cập nhật file',
    clone_file: 'Nhân bản file',
    edit_filename: 'Cập nhật tên file',
    import_products: 'Import sản phẩm',
    mass_update: 'Cập nhật hàng loạt',
    example: 'Ví dụ',
    there_are: 'Có',
    there_is: 'Có',
    row: 'Dòng',
    raw: 'Dòng',
    cannot_import_file: 'Không thể import file',
    delete_product_confirm: 'Bạn có chắc muốn xóa sản phẩm này không?',
    mass_edit: 'Chỉnh sửa hàng loạt',
    discount: 'Khuyến mãi',
    edit_type: 'Kiểu điều chỉnh',
    limited: 'Có giới hạn',
    update_selected: 'Cập nhật được chọn',
    mass_enable: 'Bật hàng loạt',
    variation_price: 'Giá phân loại',
    discounted_price: 'Giá đã giảm',
    variation: 'Phân loại',
    show: 'Hiển thị',
    selected_time_slots: 'khung giờ đã chọn',
    selected_time_slots_list: 'Các khung giờ đã chọn',
    save_and_apply: 'Lưu và áp dụng',
    discount_price: 'Giá khuyến mãi',
    overview: 'Tổng quan',
    ended_on: 'Đã kết thúc vào',
    will_end_on: 'Sẽ kết thúc vào',
    enable: 'Bật',
    disable: 'Tắt',
    login_code: 'Mã đăng nhập',
    use_cpc_duration: 'Sử dụng thời gian áp dụng CPC',
    wait_for_error: 'Lỗi. Vui lòng chờ trong vài phút trước khi tiếp tục tải dữ liệu.',
    plan: 'Kế hoạch',
    complete: 'Hoàn thành',
    use_config_confirm: '`Bạn có muốn sử dụng cấu hình này không?',
    region: 'Khu vực',
    country: 'Quốc gia',
    copied: 'Đã sao chép',
    unknown: 'Không xác định',
    other: 'Khác',
    system_error: 'Hệ thống đang trong quá trình cập nhật. Mong quý khách chờ trong giây lát!',
    notify: 'Thông báo',
    notification: 'Thông báo',
    edit_file: 'Chỉnh sửa file',
    start_hour: 'Giờ bắt đầu',
    end_hour: 'Giờ kết thúc',
    monthly: 'Hàng tháng',
    format: 'Định dạng',
    digit: 'Chữ số',
    character: 'Ký tự',
    letter: 'Chữ cái',
    quantity: 'Số lượng',
    no_data: 'Không có dữ liệu để hiển thị',
    show_saved_files: 'Xem file đã lưu',
    manual: 'Thủ công',
    mass_delete: 'Xóa hàng loạt',
    see_data: 'Xem dữ liệu',
    table: 'Bảng',
    index: 'Chỉ số',
    rank: 'Vị trí',
    logging_please_wait: 'Đang đăng nhập, vui lòng chờ',
    sign_up_title: 'ATOSA Phần mềm quảng cáo Shopee nhiều người dùng nhất',
    full_name: 'Họ và tên',
    email_address: 'Địa chỉ email',
    correct_phone_number_message: 'Quý khách vui lòng nhập đúng số điện thoại để được hỗ trợ tốt nhất',
    register_account: 'Đăng ký tài khoản',
    login_now: 'Đăng nhập ngay',
    existed_account: 'Bạn đã có tài khoản',
    learn_about_atosa: 'Tìm hiểu thêm về Công cụ hỗ trợ chạy Quảng cáo Shopee an toàn nhất',
    register_success: 'Chúc mừng bạn đã Đăng ký thành công',
    pass_sent_to_email: 'Mật khẩu đã được gửi vào Email. Bạn vui lòng đăng nhập Email để lấy mật khẩu.',
    pass_sent_to_x_email_confirm: 'Mật khẩu của bạn sẽ được gửi đến {x}. Bạn đã nhập đúng email của mình chưa?',
    join_shopee_ads_course: 'Tham gia khóa học Quảng cáo Shopee',
    login_success: 'Đăng nhập thành công',
    forgot_password: 'Quên mật khẩu',
    login: 'Đăng nhập',
    not_existed_account: 'Bạn chưa có tài khoản',
    register_now: 'Đăng ký ngay',
    sent_password_request_message: 'Chúng tôi sẽ gửi yêu cầu reset mật khẩu về địa chỉ email của bạn',
    send_request: 'Gửi yêu cầu',
    back_to_login: 'Quay trở lại trang Đăng nhập',
    send_request_password_success: 'Gửi yêu cầu xác nhận thành công',
    send_request_password_success_message: 'Nội dung xác nhận reset mật khẩu đã được gửi vào Email. Bạn vui lòng đăng nhập Email để xác nhận thông tin.',
    set_new_pass_for: 'Hãy thiết lập mật khẩu mới cho tài khoản',
    update_password_success: 'Đổi mật khẩu thành công',
    update_password_success_message: 'Mật khẩu của bạn đã được thay đổi. Vui lòng đăng nhập lại với mật khẩu mới',
    update_password: 'Cập nhật mật khẩu',
    advanced_settings: 'Cài đặt nâng cao',
    expired_package: 'Gói sản phẩm Quý khách đang sử dụng đã hết hạn vào ngày {x}. Quý khách vui lòng gia hạn gói để không bị gián đoạn trong quá trình sử dụng.',
    upcoming_expired_package: 'Gói sản phẩm Quý khách đang sử dụng sẽ hết hạn vào ngày {x}. Quý khách vui lòng gia hạn gói để không bị gián đoạn trong quá trình sử dụng.',
    renew_now: 'Gia hạn ngay',
    notice: 'Thông báo',
    update_all: 'Cập nhật tất cả',
    delete_x: 'Xóa {x}',
    delete_all_product_confirm: 'Bạn có chắc muốn xóa tất cả sản phẩm không?',
    exit: 'Thoát',
    metrics: 'chỉ số',
    device: 'Thiết bị',
    pc: 'Máy tính',
    app: 'Ứng dụng',
    others: 'Ứng dụng khác',
    date: 'Ngày',
    operator: 'Người thao tác',
    system: 'Hệ thống',
    admin: 'Quản trị viên',
    sub_account: 'Tài khoản phụ',
    update_time: 'Thời gian cập nhật',
    event_type: 'Loại sự kiện',
    details: 'Chi tiết',
    update_config: 'Cập nhật cấu hình',
    see_more: 'Xem thêm',
    not_connected: 'Chưa kết nối',
    connected: 'Đã kết nối',
    connect: 'Kết nối',
    reconnect: 'Kết nối lại',
    import_excel_file: 'Nhập file Excel',
    copy_price: 'Sao chép giá',
    all_categories: 'Tất cả danh mục',
    shopee_category: 'Ngành hàng',
    my_shop_category: 'Danh mục shop',
    see_data_by_date: 'Xem dữ liệu theo ngày',
    see_data_by_hour: 'Xem dữ liệu theo giờ',
    rating: 'Đánh giá',
    process: 'Thực hiện',
    resume_keyword_and_auto_configuration: 'Bật từ khóa và cấu hình tự động',
    pause_keyword_and_auto_configuration: 'Tạm dừng từ khóa và cấu hình tự động',
    update_data: 'Cập nhật dữ liệu',
    days: 'ngày',
    previous_month: 'Tháng trước',
    new_followers: 'Người theo dõi mới',
    include_keywords: 'Bao gồm các từ khóa',
    set_roas: 'Thiết lập mục tiêu ROAS',
    increase_roas: 'Tăng mục tiêu ROAS',
    reduce_roas: 'Giảm mục tiêu ROAS',
    max_roas: 'Mục tiêu ROAS tối đa',
    min_roas: 'Mục tiêu  ROAS tối thiểu',
    by_value: 'Theo giá trị',
    convert_json_to_automatic_condition: 'Chuyển đổi JSON sang cấu hình điều kiện tự động',
    convert_json_to_automatic_budget: 'Chuyển đổi JSON sang cấu hình ngân sách tự động',
    export_data_group_by_date: 'Tải dữ liệu nhóm theo ngày',
    product_sku: 'SKU sản phẩm',
    model_sku: 'SKU phân loại',
    edit_x: 'Chỉnh sửa {x}',
    link_to_file: 'Đang áp dụng file',
    sync_to_applied_config: 'Cập nhật các cấu hình đang áp dụng',
    delete_link: 'Xóa liên kết',
    click_to_view_detail: 'Click để xem chi tiết',
    do_action_confirm: 'Bạn có chắc chắn muốn thực hiện hành động này không?',
    keyword_metrics: 'Chỉ số từ khóa',
    ad_metrics: 'Chỉ số quảng cáo',
    group: 'Nhóm',
    best_selling: 'Bán chạy',
    potential: 'Tiềm năng',
    all_day: 'Cả ngày',
    update_x: 'Cập nhật {x}',
    adjust_x: 'Điều chỉnh {x}',
    adjust_type: 'Kiểu điều chỉnh',
    metric: 'Chỉ số',
    datetime: 'Ngày giờ',
    day: 'Ngày',
    hour: 'Giờ',
    minute: 'Phút',
    second: 'Giây',
    cost_percent: 'phần trăm Chi phí',
    product_mpd_campaign_detail: 'Chi tiết chiến dịch nhóm'
  }, // todo: end base

  input: {
    placeholder: 'Nhập nội dung tìm kiếm',
    username: 'Nhập tên đăng nhập',
    password: 'Nhập mật khẩu',
    login_code: 'Nhập mã đăng nhập',
    password_for: 'Nhập mật khẩu cho',
    otp: 'Nhập mã OTP',
    filename: 'Nhập tên file',
    max_cost: 'Nhập chi phí tối đa',
    bid_price: 'Nhập giá đấu thầu',
    budget: 'Nhập ngân sách',
    daily_budget: 'Nhập ngân sách hàng ngày',
    total_budget: 'Nhập tổng ngân sách',
    amount: 'Nhập số tiền',
    day_numbers: 'Nhập số ngày',
    bonus_amount: 'Nhập số tiền cộng thêm',
    deduction_amount: 'Nhập số tiền trừ đi',
    max_bid_price: 'Nhập giá thầu tối đa',
    min_bid_price: 'Nhập giá thầu tối thiểu',
    starting_bid_price: 'Nhập giá thầu khởi điểm',
    value: 'Nhập giá trị',
    expected_cir: 'Nhập tỉ lệ CIR mong muốn',
    expected_roas: 'Nhập tỉ lệ ROAS mong muốn',
    expected_exclude_cancelled_roi: 'Nhập tỉ lệ ROI đã trừ huỷ mong muốn',
    starting_budget: 'Nhập ngân sách đầu ngày',
    max_budget: 'Nhập ngân sách tối đa',
    config_name: 'Nhập tên cấu hình',
    tag_name: 'Nhập tên thẻ',
    filter_name: 'Nhập tên bộ lọc',
    config_file_name: 'Nhập tên file cấu hình',
    config_code: 'Nhập mã cấu hình',
    percent: 'Nhập phần trăm',
    ad_name: 'Nhập tên quảng cáo',
    tagline: 'Nhập khẩu hiệu',
    bonus_premium_rate: 'Nhập mức premium cộng thêm',
    max_premium_rate: 'Nhập mức premium tối đa',
    premium_rate: 'Nhập mức premium',
    reduction_premium_rate: 'Nhập mức premium trừ đi',
    min_premium_rate: 'Nhập mức premium tối thiểu',
    campaign_id: 'Nhập mã chiến dịch',
    keyword: 'Nhập từ khóa',
    select_time: 'Chọn thời gian',
    start_time: 'Chọn thời gian bắt đầu',
    end_time: 'Chọn thời gian kết thúc',
    start_month: 'Chọn tháng bắt đầu',
    end_month: 'Chọn tháng kết thúc',
    time: 'Chọn thời gian',
    text: 'Nhập nội dung',
    product_group_name: 'Nhập tên nhóm sản phẩm',
    new_text: 'Nhập đoạn text mới',
    replace_text: 'Nhập đoạn text thay thế',
    voucher_name: 'Nhập tên voucher',
    voucher_code: 'Nhập mã voucher',
    template_name: 'Nhập tên mẫu',
    format: 'Nhập định dạng',
    full_name: 'Nhập họ và tên',
    email_address: 'Nhập địa chỉ email',
    phone_number: 'Nhập số điện thoại',
    new_password: 'Nhập mật khẩu mới',
    confirm_password: 'Nhập lại mật khẩu',
    max_bid_value: 'Nhập giá trị tối đa',
    min_bid_value: 'Nhập giá trị tối thiểu',
  }, // todo: end input

  required: {
    username: 'Vui lòng nhập tên đăng nhập',
    password: 'Vui lòng nhập mật khẩu',
    select: 'Vui lòng chọn',
    input: 'Vui lòng nhập',
    select_sub_account: 'Vui lòng chọn tài khoản phụ trách',
    set_rule_for_sub_account: 'Vui lòng phân quyền cho tài khoản phụ trách',
    start_time: 'Vui lòng chọn thời gian bắt đầu',
    end_time: 'Vui lòng chọn thời gian kết thúc',
    amount: 'Vui lòng nhập số tiền',
    bid_price: 'Vui lòng nhập giá đấu thầu',
    filename: 'Vui lòng nhập tên file',
    select_file: 'Vui lòng chọn file',
    action: 'Vui lòng chọn hành động',
    action_to_handle: 'Vui lòng chọn hành động xử lý',
    i_or_d_type: 'Vui lòng chọn kiểu tăng / giảm',
    i_or_d_value: 'Vui lòng nhập giá trị tăng / giảm',
    cpc_duration: 'Vui lòng chọn thời gian áp dụng CPC',
    full_filter_data: 'Vui lòng nhập đủ dữ liệu cho bộ lọc',
    add_config: 'Vui lòng thêm cấu hình',
    specific_day: 'Vui lòng chọn ngày chỉ định',
    expected_cir: 'Vui lòng nhập tỉ lệ CIR mong muốn',
    applied_keyword_type: 'Vui lòng chọn loại từ khóa áp dụng',
    min_bid_price: 'Vui lòng nhập giá thầu tối thiểu',
    max_bid_price: 'Vui lòng nhập giá thầu tối đa',
    max_cost_if_gmv_by_0: 'Vui lòng nhập chi phí tối đa nếu GMV bằng 0',
    max_bid_price_for_exact: 'Vui lòng nhập giá thầu tối đa cho từ khóa chính xác',
    max_bid_price_for_broad: 'Vui lòng nhập giá thầu tối đa cho từ khóa mở rộng',
    select_runtime: 'Vui lòng chọn đầy đủ thời gian chạy',
    select_advanced_runtime: 'Vui lòng chọn đầy đủ thời gian chạy nâng cao',
    configuration_active_day: 'Vui lòng chọn ngày hoạt động',
    bonus_amount: 'Vui lòng nhập số tiền cộng thêm',
    cir_type: 'Vui lòng chọn loại CIR',
    check_duration: 'Vui lòng chọn thời gian kiểm tra',
    must_select_at_least: 'Vui lòng chọn ít nhất 1 tùy chọn',
    starting_budget: 'Vui lòng nhập ngân sách đầu ngày',
    budget_type: 'Vui lòng chọn kiểu ngân sách',
    budget: 'Vui lòng nhập ngân sách',
    add_advanced_config: 'Vui lòng thêm cấu hình nâng cao',
    percent_of_recommend_price: 'Vui lòng nhập phần trăm giá đề xuất',
    full_data: 'Vui lòng nhập đủ dữ liệu',
    select_products_for_creating_ad: 'Vui lòng chọn sản phẩm để tạo quảng cáo',
    must_select_at_least_product: 'Vui lòng chọn ít nhất 1 sản phẩm',
    must_select_at_least_keyword: 'Vui lòng chọn ít nhất 1 từ khóa',
    select_product: 'Vui lòng chọn sản phẩm',
    ad_name: 'Vui lòng nhập tên quảng cáo',
    ad_duration: 'Vui lòng chọn thời gian chạy chiến dịch',
    bonus_premium_rate: 'Vui lòng nhập mức premium cộng thêm',
    max_premium_rate: 'Vui lòng nhập mức premium tối đa',
    reduction_premium_rate: 'Vui lòng nhập mức premium trừ đi',
    min_premium_rate: 'Vui lòng nhập mức premium tối thiểu',
    premium_rate: 'Vui lòng nhập mức premium',
    min_premium_rate_is_x: 'Mức premium tối thiểu là {x}',
    max_premium_rate_is_x: 'Mức premium tối đa là {x}',
    audience_name: 'Vui lòng nhập tên đối tượng',
    audience_group_name: 'Vui lòng nhập tên nhóm đối tượng',
    not_exceed_max: 'Số lượng từ khóa không được phép vượt {x} từ. Số từ khóa hiện tại {c} từ',
    tagline: 'Vui lòng nhập khẩu hiệu quảng cáo',
    tagline_not_includes: 'Khẩu hiệu quảng cáo của bạn không thể chứa “!@^*{};<>”',
    campaign_id: 'Vui lòng nhập mã chiến dịch',
    select_keywords: 'Vui lòng chọn từ khóa',
    select_duration: 'Vui lòng chọn thời gian',
    select_products_to_create: 'Vui lòng chọn sản phẩm để tạo',
    select_product_to_analyze: 'Vui lòng chọn sản phẩm để phân tích',
    select_image_to_remove_frame: 'Vui lòng chọn ảnh để xóa khung',
    new_product_name: 'Vui lòng nhập tên sản phẩm mới',
    replace_text: 'Vui lòng nhập đoạn text thay thế',
    new_replace_text: 'Vui lòng nhập đoạn text mới',
    select_frame: 'Vui lòng chọn khung',
    select_cover_image: 'Vui lòng chọn ảnh bìa',
    select_group: 'Vui lòng chọn nhóm',
    group_name: 'Vui lòng nhập tên nhóm',
    remove_text: 'Vui lòng nhập đoạn text cần xóa',
    select_products: 'Vui lòng chọn sản phẩm',
    shop: 'Vui lòng chọn cửa hàng',
    time_slot: 'Vui lòng chọn khung giờ',
    percent: 'Vui lòng nhập phần trăm',
    template_name: 'Vui lòng nhập tên mẫu',
    voucher_name: 'Vui lòng nhập tên voucher',
    voucher_code: 'Vui lòng nhập mã voucher',
    voucher_max_x_length: 'Mã voucher không được vượt quá {x} ký tự',
    discount_price: 'Vui lòng nhập giá khuyến mãi',
    discount_percent: 'Vui lòng nhập phần trăm khuyến mãi',
    shop_url: 'Vui lòng nhập link shop',
    full_name: 'Nhập tên của bạn để chúng tôi chăm sóc tốt hơn!',
    phone_number: 'Nhập số điện thoại của bạn để để chúng tôi có thể tư vấn và hỗ trợ!',
    email_address: 'Nhập email để chúng tôi có thể gửi mật khẩu đăng nhập cho bạn!',
    captcha: 'Vui lòng xác nhận mã Captcha',
    update_new_password: 'Cập nhật mật khẩu mới',
    not_math_password: 'Mật khẩu xác nhận không khớp',
    at_least_6_letter: 'Mật khẩu phải chứa ít nhất 6 ký tự',
    target_broad_roi: 'Vui lòng nhập mục tiêu ROAS',
    products_or_campaigns: 'Vui lòng chọn sản phẩm hoặc chiến dịch',
    config_name: 'Vui lòng nhập tên cấu hình',
    time: 'Vui lòng chọn thời gian',
    feature: 'Vui lòng chọn ít nhất 1 tiêu chí',
    period_times: 'Vui lòng chọn khung giờ chạy',
    value: 'Vui lòng nhập giá trị',
  }, // todo: end required

  button: {}, // todo: end button

  select: {
    shop: 'Chọn cửa hàng',
    compare_duration: 'Chọn khung thời gian đối chiếu',
    action: 'Chọn hành động',
    keyword_file: 'Chọn file từ khóa',
    report_duration: 'Chọn khung giờ báo cáo',
    file: 'Chọn file',
    tags: 'Chọn thẻ',
    time: 'Chọn thời gian',
    active_day: 'Vui lòng chọn ngày hoạt động',
    campaign_type: 'Chọn loại chiến dịch',
    ad_type: 'Chọn loại quảng cáo',
    time_period_for_analysis: 'Chọn khoảng thời gian phân tích',
    group: 'Chọn nhóm',
    time_slot: 'Chọn khung giờ',
    products: 'Chọn sản phẩm',
    hour: 'Chọn giờ',
    start_time: 'Chọn thời gian bắt đầu',
    end_time: 'Chọn thời gian kết thúc',
    category: 'Chọn danh mục',
    month: 'Chọn tháng',
  }, // todo: end select

  menu: {
    shopee_shops: 'Cửa hàng Shopee',
    sub_accounts: 'Tài khoản phụ trách',
    atosa_packages: 'Gói sản phẩm Atosa',
    topup_payment: 'Nạp tiền / Thanh toán',
    shopee_ads_course: 'Khóa học Shopee Ads',
    shopee_mall_offering: 'Dịch vụ Shoppe Mall',
    affiliate: 'Tiếp thị liên kết',
    user_guide: 'Hướng dẫn sử dụng',
    download_desktop_app: 'Tải App cho máy tính',
    customer_support_channel: 'Kênh hỗ trợ khách hàng',
    logout_account: 'Đăng xuất tài khoản',
    shop_analysis: 'Phân tích đối thủ',
    shopee_research: 'Khảo sát thị trường',
    ads_planning: 'Kế hoạch quảng cáo',
    order_planning: 'Kế hoạch theo đơn',
    atosa_keyword_tool: 'Công cụ từ khóa Atosa',
    automatic_ads: 'Quảng cáo tự động',
    ad_position_check: 'Spy vị trí Quảng cáo',
    shop_products: 'Sản phẩm của shop',
    shop_flash_sale: 'Flash Sale của shop',
    shopee_flash_sale: 'Flash Sale của sàn',
    shop_vouchers: 'Voucher của shop',
    business_insights: 'Phân tích bán hàng',
    ads_insights: 'Phân tích quảng cáo',
    monthly_reporting: 'Báo cáo theo tháng',
    customer_insights: 'Phân tích insight',
    shopee_analysis: 'Nghiên cứu thị trường',
    planning: 'Lập kế hoạch',
    atosa_tools: 'Công cụ Atosa',
    shopee_ads: 'Quảng cáo Shopee',
    automatic_marketing: 'Marketing tự động',
    reporting: 'Báo cáo',
    management: 'Quản lý',
    package: 'Gói',
    payment: 'Thanh toán',
    operation: 'Tác vụ',
    use_basic_menu: 'Sử dụng menu cơ bản',
    use_advanced_menu: 'Sử dụng menu nâng cao',
    select_os: 'Chọn hệ điều hành',
  }, // todo: end menu

  profile: {
    note1: ' Vui lòng cập nhật thông tin của bạn để chúng tôi có thể hỗ trợ khi có vấn đề hoặc khi quên mật khẩu.',
  }, // todo: end profile

  shop: {
    list: 'Danh sách cửa hàng',
    add: 'Thêm cửa hàng',
    add_by_code: 'Thêm cửa hàng bằng mã',
    guide: {
      1: 'Hướng dẫn thêm cửa hàng trên Atosa',
      2: 'Hướng dẫn đổi tên cửa hàng trên Atosa',
      3: 'Hướng dẫn xử lý lỗi hay gặp khi đăng nhập cửa hàng',
      4: 'Để khôi phục lại các cấu hình khi xóa cửa hàng, quý khách vui lòng liên hệ với bộ phận CSKH để được hỗ trợ, thời gian xử lý từ 1-2 ngày.',
    },
    using_system_proxy: 'Đang sử dụng proxy hệ thống',
    login: 'Đăng nhập shop',
    re_login: 'Đăng nhập lại',
    delete: 'Xóa shop',
    google: {
      list: 'Danh sách tài khoản Google',
      account_id: 'ID tài khoản',
      account_name: 'Tên tài khoản',
      connect: 'Kết nối tài khoản',
      delete: 'Xóa tài khoản',
    },
    cannot_verify_otp: 'Không thể xác thực OTP',
    extension_link: 'Link cài đặt extension hỗ trợ đăng nhập cửa hàng',
    extension_video: 'Video hướng dẫn thêm cửa hàng bằng mã đăng nhập',
    add_success: 'Thêm cửa hàng thành công',
    login_success_account: 'Đăng nhập thành công tài khoản',
    cannot_get_shop_info: 'Không thể lấy thông tin cửa hàng',
    config_shop_success: 'Cấu hình cửa hàng thành công',
    selected_default: 'Đã chọn cửa hàng mặc định',
    confirm_before_delete: 'Bạn có chắc muốn xóa tài khoản {x} không? Lưu ý, toàn bộ cấu hình cài đặt tự động của cửa hàng có thể sẽ bị xóa.',
    incorrect_account: 'Tài khoản hoặc mật kẩu không đúng',
    get_method_login_error: 'Đã có lỗi xảy ra khi lấy phương thức xác nhận OTP. Quý khách vui lòng báo với quản trị viên để được hỗ trợ.',
    verify_sms: 'Quý khách vui lòng xác nhận liên kết được gửi tới tin nhắn SMS để liên kết shop. Thời gian xác nhận là {x} giây.',
    verify_email: 'Quý khách vui lòng xác nhận liên kết được gửi tới Email để liên kết shop. Thời gian xác nhận là {x} giây.',
    method_not_supported: 'Phương thức xác nhận chưa được hỗ trợ. Quý khách vui lòng liên hệ với bộ phận CSKH để được hỗ trợ.',
    wait_for_logging: 'Vui lòng đợi trong giây lát, hệ thống đang thực hiện đăng nhập vào cửa hàng',
    method_not_found: 'Không tìm thấy phương thức đăng nhâp tài khoản. Quý khách vui lòng liên hệ với bộ phận kỹ thuật để được hỗ trợ.',
    login_success_shop: 'Đăng nhập thành công cửa hàng',
    cannot_login_shop: 'Không thể đăng nhập cửa hàng! Quý khách vui lòng thêm cửa hàng bằng mã đăng nhập hoặc liên hệ với quản trị viên để được hỗ trợ',
    error_banned: 'Không thể lấy dữ liệu của tài khoản, quý khách vui lòng kiểm tra và thử lại sau!',
    error_require_captcha: 'Yêu cầu nhập mã captcha! Quý khách vui lòng đăng nhập thành công trên trình duyệt sau đó đăng nhập lại trên Atosa!',
    error_captcha: 'Captcha không đúng, quý khách vui lòng thử lại sau!',
    error_notfound: 'Tài khoản không tồn tại, quý khách vui lòng kiểm tra và thử lại sau!',
    error_need_otp: 'Yêu cầu OTP, vui lòng nhập mã OTP!',
    has_error: 'Đã xảy ra lỗi khi đăng nhập cửa hàng',
    connect_proxy_success: 'Kết nối proxy thành công',
    connect_proxy_failed: 'Kết nối proxy thất bại',
    invalid_proxy: 'Proxy không hợp lệ',
    name: 'Tên cửa hàng',
    added: 'Cửa hàng đã thêm',
    managed: 'Cửa hàng phụ trách',
    select_for: 'Vui lòng chọn cửa hàng để sử dụng tính năng này',
    connected_to: 'Đã kết nối đến cửa hàng',
    connect_error: 'Đã có lỗi xảy ra khi kết nối cửa hàng. Vui lòng thử kết nối lại sau!',
    connect_shop_error: 'Đã có lỗi xảy ra khi kết nối cửa hàng',
    error_require_otp: 'Tài khoản của quý khách chưa xác thực OTP. Vui lòng đăng nhập lại tài khoản ở mục Cửa hàng Shopee!',
    all: 'Tất cả cửa hàng',
    need_to_add_shop_message: 'Quý khách chưa thêm cửa hàng nào. Vui lòng thêm cửa hàng để sử dụng tính năng này',
    add_now: 'Thêm cửa hàng ngay',
    connect_ads_platform_success: 'Kết nối hệ thống Atosa Ads Platform thành công',
  }, // todo: end shop

  package: {
    has_expired: 'Gói dịch vụ của quý khách đã hết hạn',
    x_has_expired: 'Gói dịch vụ {x} của quý khách đã hết hạn. Vui lòng áp dụng gói để tiếp tục sử dụng.',
    not_for_trial: 'Tính năng này không áp dụng cho gói dùng thử',
  }, // todo: end package

  sub_accounts: {
    invitation_send: 'Lời mời đã gửi',
    send_invitation: 'Gửi lời mời phụ trách',
    cancel_invitation: 'Hủy lời mời',
    has_no_sub_account: 'Chưa có tài khoản phụ trách',
    select_sub_account: 'Chọn tài khoản phụ trách',
    set_rule: 'Phân quyền',
    set_rule_success: 'Phân quyền thành công',
    delete_rule: 'Xóa phân quyền',
    invitation_accounts: 'Danh sách tài khoản đã mời',
    invitation_shops: 'Danh sách cửa hàng đã mời',
    managed_shops: 'Danh sách cửa hàng phụ trách',
    main_account: 'Tài khoản chính',
    invitation_by: 'Người gửi lời mời',
    show_rule: 'Xem bảng phân quyền',
    rule_table: 'Bảng phân quyền',
    add_account: 'Thêm tài khoản',
    error_feature_not_found: 'Lỗi phân quyền: Không tìm thấy tính năng!',
    error_role_not_found: 'Lỗi phân quyền: Không tìm thấy hành động!',
    error_cannot_access: 'Bạn không có quyền truy cập tính năng',
  }, // todo: end sub_accounts

  ads: {
    search_ads: 'Quảng cáo tìm kiếm',
    discover_ads: 'Quảng cáo khám phá',
    shop_ads: 'Quảng cáo shop',
    show_campaigns: 'Xem chiến dịch',
    create_campaigns: 'Tạo chiến dịch',
    update_campaigns: 'Cập nhật chiến dịch',
    add_keywords: 'Thêm từ khóa',
    added_keywords: 'Từ khóa đã thêm',
    update_keywords: 'Cập nhật từ khóa',
    delete_keywords: 'Xóa từ khóa',
    config_auto: 'Cấu hình quảng cáo tự động',
    anti_click: 'Chống click ảo',
    ads_credit: 'Số dư tài khoản Quảng cáo',
    ads_guide: 'Hướng dẫn cài đặt Quảng cáo Shopee',
    atosa_ads: 'Quảng cáo Atosa',
    all_cpc_ads: 'Tất cả quảng cáo trả theo CPC',
    product_ads: 'Quảng cáo sản phẩm',
    view_data_by_hour: 'Xem dữ liệu theo giờ',
    viewing_data_by_hour: 'Thoát chế độ xem dữ liệu theo giờ',
    exit_view_data_by_hour: 'Xem dữ liệu theo giờ',
    create_new_campaign: 'Tạo chiến dịch mới',
    select_ads_type: 'Chọn loại quảng cáo',
    low_balance_message: 'Số dư tài khoản quảng cáo thấp. Vui lòng nạp thêm tiền để đảm bảo các chương trình quảng cáo không bị gián đoạn.',
    surge: {
      title: 'Quảng Cáo Shopee Shop của tôi',
      note: 'Thiết lập tại mục Thiết lập Shop sẽ được áp dụng cho tất cả Quảng cáo đang chạy của Shop. Shop có thể điều chỉnh những thiết lập này bất kỳ lúc nào.',
      setting: 'Tối Ưu Hóa Giá Đấu Thầu Ngày Sale',
    },
    conditional_configuration: 'Cấu hình tự động theo điều kiện',
    conditional_automatic_configuration: 'Cấu hình tự động theo điều kiện',
    optimize_based_on_conditional: 'Tối ưu theo điều kiện',
    change_budget: 'Điều chỉnh ngân sách',
    change_budget_configuration: 'Cấu hình Điều chỉnh ngân sách tự động',
    mass_update: 'Cập nhật hàng loạt',
    mass_configuration: 'Cấu hình hàng loạt',
    select_metrics: 'Chọn chỉ số',
    campaign_list: 'Danh sách chiến dịch',
    loading_campaign_list: 'Đang tải danh sách chiến dịch',
    all: 'Tất cả chiến dịch',
    all_campaign: 'Tất cả chiến dịch',
    with_low_performance: 'Chiến dịch hiệu quả thấp',
    with_very_low_performance: 'Chiến dịch hiệu quả rất thấp',
    with_average_performance: 'Chiến dịch hiệu quả trung bình',
    with_high_performance: 'Chiến dịch hiệu quả cao',
    automatic_configuration: 'Cấu hình tự động',
    placeholder_search_by: 'Tìm kiếm theo product id, campaign id, tên campaign,...',
    optimize_based_on_cir: 'Tối ưu theo CIR',
    optimize_audience_based_on_cir: 'Tối ưu đối tượng theo CIR',
    optimize_based_on_cir_advanced: 'Tối ưu theo CIR nâng cao',
    optimize_based_on_cir_configuration: 'Cấu hình Tối ưu theo CIR',
    optimize_based_on_cir_advanced_configuration: 'Cấu hình Tối ưu theo CIR nâng cao',
    automatic_budget: 'Ngân sách tự động',
    automatic_budget_configuration: 'Cấu hình ngân sách tự động',
    auto_bidding: 'Tự động',
    manual_bidding: 'Thủ công',
    search: 'Tìm kiếm',
    targeting: 'Khám phá',
    with_low_budget: 'Chiến dịch ngân sách thấp',
    running_out_of_budget_message: 'Chi phí của chương trình đang dần đạt đến giới hạn ngân sách bạn thiết lập và chương trình sẽ tạm dừng khi hết ngân sách. Hãy gia tăng ngân sách nếu bạn muốn tiếp tục chương trình nhé!',
    duration: 'Thời gian áp dụng',
    select_duration: 'Thiết lập ngày bắt đầu/kết thúc',
    select_products_for_creating_ad: 'Chọn sản phẩm để tạo quảng cáo',
    anti_click_configuration: 'Cấu hình chống click ảo',
    anti_click_label: {
      type1: 'Tỉ lệ % Lượt chuyển đổi / số click',
      type2: 'Tỉ lệ % CIR (Chi phí / GMV)',
      minimum_clicks: 'Số lượt click tối thiểu',
      maximum_clicks: 'Số lượt click tối đa',
      broad_cir: 'CIR mở rộng',
      direct_cir: 'CIR trực tiếp',
      maximum_cost: 'Chi phí tối đa',
      check_if_gmv_by_0: 'Kiểm tra khi không có đơn hàng (GMV bằng 0)',
      max_cost_if_gmv_by_0: 'Chi phí tối đa của từ khóa khi không có đơn',
      action_when_detect: 'Hành động khi phát hiện click ảo',
      confirm_1: 'Bạn đang bật chế độ Không có đơn hàng nhưng chưa cài đặt Chi phí tối đa, điều này có thể khiến từ khóa bị dừng ngay lập tức! Bạn vẫn muốn tiếp tục?',
      confirm_2: 'Bạn đang bật chế độ Không có đơn hàng nhưng Chi phí tối đa quá thấp, điều này có thể khiến từ khóa bị dừng ngay lập tức! Bạn vẫn muốn tiếp tục?',
    },
    general_label: {
      edit_amount: 'Điều chỉnh giá thầu theo số tiền',
      pause_object: 'Tạm dừng từ khóa hoặc quảng cáo',
      not_exceed_max: 'Không vượt quá giá tối đa',
      edit_by_realtime_cpc: 'Điều chỉnh giá thầu theo CPC ngày',
      higher_message: 'Cao hơn số tiền so với giá thầu gợi ý hoặc giá trị CPC',
      not_exceeding_max: 'Không vượt quá tối đa',
    },
    auto_position: 'Duy trì vị trí tự động',
    advanced_auto_position: 'Duy trì vị trí tự động nâng cao',
    auto_position_configuration: 'Cấu hình duy trì vị trí tự động',
    advanced_auto_position_configuration: 'Cấu hình duy trì vị trí tự động nâng cao',
    auto_price: 'Đấu thầu tự động',
    auto_price_configuration: 'Cấu hình đấu thầu tự động',
    auto_price_label: {
      lower_message: 'Thấp hơn số tiền so với giá thầu gợi ý hoặc giá trị CPC',
      higher_x_message: 'Cao hơn x % so với giá thầu gợi ý hoặc giá trị CPC',
      lower_x_message: 'Thấp hơn x % so với giá thầu gợi ý hoặc giá trị CPC',
      by_amount_or_cpc: 'Thiết lập giá thầu theo giá gợi ý của Shopee hoặc giá trị CPC',
    },
    auto_position_label: {
      from_position: 'Bắt đầu từ',
      to_position: 'Cho tới',
      input_from: 'Nhập vị trí bắt đầu',
      input_to: 'Nhập vị trí kết thúc',
      input_position: 'Nhập vị trí',
      always_above: 'Luôn duy trì ở phía trên vị trí',
      always_below: 'Luôn duy trì ở phía dưới vị trí',
      bid_price_to_increase: 'Số tiền cộng thêm để tăng vị trí',
      bid_price_to_decrease: 'Số tiền trừ đi để giảm vị trí',
      only_apply_with_exact: 'Chỉ áp dụng với từ khóa chính xác',
      advanced_note: 'Tính năng này chỉ áp dụng với những từ khóa đã cài cấu hình Duy trì vị trí tự động',
      deduction_bid_price_when_target_position: 'Số tiền trừ đi khi đạt vị trí mong muốn',
      include_broad_keyword: 'Lưu ý: Trong danh sách cấu hình có từ khóa mở rộng, những từ khóa này sẽ không thể kiểm tra được vị trí chính xác. Bạn có muốn tiếp tục?',
      select_type: 'Chọn kiểu duy trì hiển thị',
      select_type_search: 'Tăng giá thầu cho tới khi Hiển thị trên trang kết quả tìm kiếm',
      select_type_impression: 'Tăng giá thầu cho tới khi có Lượt xem trong báo cáo',
      select_type_click: 'Tăng giá thầu cho tới khi có Lượt click trong báo cáo',
      reduce_if: 'Số tiền trừ đi sau khi đã hiển thị',
    },
    other_setups: 'Cài đặt khác',
    check_position_on: 'Kiểm tra vị trí theo',
    advanced_configuration: 'Cài đặt nâng cao',
    configuration_active_day: 'Ngày hoạt động',
    configuration_active_day_list: 'Danh sách ngày hoạt động',
    advanced_mass_edit: 'Cài đặt nâng cao hàng loạt',
    edit_by_bid_price: 'Điều chỉnh theo giá thầu',
    bonus_by_basic_config: 'Tăng theo số tiền so với giá thầu tối đa của Cài đặt cơ bản',
    bonus_percent_by_basic_config: 'Tăng theo phần trăm so với giá thầu tối đa của Cài đặt cơ bản',
    max_edit_max_bid_price: 'Điều chỉnh Giá thầu tối đa hàng loạt',
    apply_for_auto_position: 'Áp dụng với cấu hình Duy trì vị trí',
    automatic_config: 'Cấu hình tự động',
    manual_config: 'Cấu hình tùy chỉnh',
    from: 'Từ lúc',
    to: 'Đến lúc',
    auto_quota_label: {
      unlimited: 'Không giới hạn ngân sách',
      nothing: 'Giữ nguyên ngân sách cài đặt',
      pause: 'Tạm dừng chiến dịch (Không khuyến nghị)',
    },
    auto_cir_label: {
      to_reach_target: 'để đạt mức CIR mong muốn',
      allow_when_above_target: 'Cho phép điều chỉnh từ khóa khi CIR cao hơn mức cài đặt',
      use_keyword_cir: 'Sử dụng CIR của từ khóa',
      use_campaign_cir: 'Sử dụng CIR của chiến dịch',
      advanced_note_1: 'Cấu hình sẽ sử dụng CIR trong ngày để tối ưu quảng cáo.',
      advanced_note_2: 'Cấu hình này dành riêng cho ngày Sale và khung giờ được cài đặt. Nếu nằm ngoài khung giờ này , hệ thống sẽ chạy cấu hình tối ưu theo CIR cơ bản.',
      advanced_type_lte: 'Áp dụng với những từ khóa có CIR Nhỏ hơn hoặc bằng mức CIR mong muốn',
      advanced_type_gt: 'Áp dụng với những từ khóa có CIR Lớn hơn mức CIR mong muốn',
      advanced_type_not: 'Áp dụng với những từ khóa chưa có CIR (CIR = 0)',
      max_bid_price_for_exact: 'Giá thầu tối đa cho từ khóa chính xác',
      max_bid_price_for_broad: 'Giá thầu tối đa cho từ khóa mở rộng',
      bid_price_when_outside_runtime: 'Giá thầu khi không nằm trong Khung giờ cài đặt',
      max_cost_if_gmv_by_0: 'Chi phí tối đa của quảng cáo khi không có đơn',
      audience_allow_case_1: 'Cho phép điều chỉnh đối tượng khi CIR cao hơn mức cài đặt',
      audience_pause: 'Tạm dừng đối tượng',
      audience_value: 'Điều chỉnh mức premium theo giá trị',
      audience_reduce: 'Giảm dần mức premium theo thời gian',
      audience_max_cost_if_gmv_by_0: 'Chi phí tối đa của đối tượng khi không có đơn',
      audience_user_guide: 'Hệ thống sẽ tăng mức premium của đối tượng khi CIR của đối tượng thấp hơn mức CIR cài đặt hoặc khi CIR bằng 0 và chưa có đơn hàng nào.',
    },
    time_based_bid_reduction: 'Giảm dần theo thời gian',
    action_when_exceeding_cost: 'Hành động khi vượt quá chi phí',
    action_when_running_out_of_cir: 'Hành động khi vượt quá CIR mong muốn',
    action_when_running_out_of_cost: 'Hành động khi hết chi phí',
    action_when_running_out_of_budget: 'Hành động khi hết ngân sách',
    x_value_with_budget: '{x} [Giá trị] % so với ngân sách',
    x_with_ads_planning: '{x} kế hoạch quảng cáo',
    keyword_cpc: 'CPC của từ khóa',
    ad_cpc: 'CPC của quảng cáo',
    campaign_cpc: 'CPC của chiến dịch',
    shop_cpc: 'CPC của shop',
    activity_frequency: 'Tần suất hoạt động',
    each_30_minutes: 'Chạy quy tắc 30 phút một lần và mỗi lần chạy sẽ mất chút thời gian.',
    each_30_minutes_with_specific: 'Chạy quy tắc 30 phút hoặc 60 phút một lần vào khoảng thời gian cụ thể.',
    once_a_day: 'Chỉ chạy một lần trong ngày và quy tắc sẽ tự động tắt sau khi chạy.',
    clone_campaign_result: 'Kết quả nhân bản chiến dịch quảng cáo',
    clone_success: 'Nhân bản chiến dịch thành công',
    clone_fail: 'Nhân bản chiến dịch thất bại',
    cannot_clone: 'Không thể nhân bản chiến dịch',
    manual_shop_ads: 'Quảng cáo shop (Thủ công)',
    auto_shop_ads: 'Quảng cáo shop (Tự động)',
    all_ads: 'Quảng cáo tất cả',
    targeting_ads: 'Quảng cáo khám phá',
    manual: 'Thủ công',
    auto: 'Tự động',
    manual_all_ads: 'Quảng cáo tất cả thủ công',
    auto_all_ads: 'Quảng cáo tất cả tự động',
    manual_search_ads: 'Quảng cáo tìm kiếm thủ công',
    auto_search_ads: 'Quảng cáo tìm kiếm tự động',
    manual_targeting_ads: 'Quảng cáo khám phá thủ công',
    auto_targeting_ads: 'Quảng cáo khám phá tự động',
    create_campaigns_result: 'Kết quả tạo chiến dịch quảng cáo',
    cannot_create_campaign: 'Không thể tạo chiến dịch',
    back_to_campaigns: 'Quay trở về trang quảng cáo',
    there_are_multiple_ongoing_message: 'Có nhiều quảng cáo đang chạy cho sản phẩm này. Để hiển thị sản phẩm hiệu quả, hệ thống Shopee chỉ hiển thị một quảng cáo đến người mua tại một thời điểm.',
    there_are_multiple_ongoing_see_detail: 'Xem thêm các quảng cáo khác cho sản phẩm này',
    campaign_is_good: 'Chiến dịch đang chạy hiệu quả.',
    campaign_is_not_good: 'Chiến dịch đang chạy chưa hiệu quả, bạn cần tối ưu lại Quảng cáo và Sản phẩm.',
    mass_setup_auto_configuration: 'Cài đặt tự động hàng loạt',
    mass_setup_anti_click_configuration: 'Cài đặt chống click ảo hàng loạt',
    mass_setup_optimize_based_on_cir_configuration: 'Cài đặt tối ưu theo CIR hàng loạt',
    mass_setup_conditional_automatic_configuration: 'Cài đặt tự động theo điều kiện hàng loạt',
    mass_setup_advanced_configuration: 'Cài đặt nâng cao hàng loạt',
    mass_delete_auto_configuration: 'Xóa cài đặt tự động hàng loạt',
    mass_delete_advanced_auto_configuration: 'Xóa cài đặt tự động nâng cao hàng loạt',
    mass_delete_anti_click_configuration: 'Xóa cài đặt chống click ảo hàng loạt',
    mass_delete_optimize_based_on_cir_configuration: 'Xóa cài đặt tối ưu theo CIR hàng loạt',
    max_edit_max_bid_price_of_auto_position: 'Điều chỉnh giá thầu tối đa (Duy trì vị trí)',
    mass_delete_conditional_automatic_configuration: 'Xóa cài đặt tự động theo điều kiện hàng loạt',
    mass_add_keywords: 'Thêm từ khóa hàng loạt',
    mass_edit_keywords_bid_price: 'Chỉnh sửa giá thầu từ khóa hàng loạt',
    mass_edit_keywords_by_condition: 'Điều chỉnh Từ khóa hàng loạt theo điều kiện',
    mass_edit_discovery_bid_price: 'Điều chỉnh giá thầu Khám phá hàng loạt',
    resume_pause_delete_configuration: 'Bật / Tắt / Xóa cài đặt tự động',
    resume: 'Bật',
    pause: 'Tắt',
    auto_configuration: 'Cấu hình tự động',
    recommend_price: 'Giá gợi ý',
    new_custom_audience: 'Tạo đối tượng mới',
    audience_note: 'Quảng cáo của bạn sẽ tự động sử dụng tính năng Tùy chỉnh Đối tượng Mục tiêu khi bạn tạo Đối tượng Tùy chỉnh.',
    active: 'Kích hoạt',
    bid_price_when_not_cpc: 'Giá thầu khi không có CPC',
    i_or_d_by_rmd_or_cpc_by_amount: 'Tăng / giảm giá thầu theo số tiền của Giá gợi ý hoặc CPC',
    i_or_d_by_rmd_or_cpc_by_percent: 'Tăng / giảm giá thầu theo phần trăm của Giá gợi ý hoặc CPC',
    set_by_rmd_or_cpc: 'Thiết lập giá thầu theo Giá gợi ý hoặc CPC',
    atosa_use_0_note: 'Atosa sẽ sử dụng Giá gợi ý của Shopee nếu giá trị CPC bằng 0.',
    average_ranking: 'Vị trí trung bình',
    convert_position_table: 'Bảng quy đổi vị trí giữa Web và App Shopee.',
    website_position: 'Vị trí trên website',
    mobile_position: 'Vị trí trên mobile',
    auto_cir_advanced_note: 'Cấu hình sẽ sử dụng tỉ lệ CIR trong ngày để tối ưu quảng cáo.',
    shop_page: 'Trang chủ shop (Mặc định)',
    linked_page: 'Trang liên kết',
    edit_image: 'Chỉnh sửa hình ảnh',
    suggested: 'Mức gợi ý',
    condition_label: {
      cpc_today: 'Phần trăm của CPC từ khóa ngày hôm nay',
      cpc_yesterday: 'Phần trăm của CPC từ khóa ngày hôm qua',
      cpc_week: 'Phần trăm của CPC từ khóa 7 ngày qua',
      cpc_month: 'Phần trăm của CPC từ khóa 30 ngày qua',
      cpc_ad_today: 'Phần trăm của CPC quảng cáo ngày hôm nay',
      cpc_ad_yesterday: 'Phần trăm của CPC quảng cáo ngày hôm qua',
      cpc_ad_week: 'Phần trăm của CPC quảng cáo 7 ngày qua',
      cpc_ad_month: 'Phần trăm của CPC quảng cáo 30 ngày qua',
      cpc_campaign_today: 'Phần trăm của CPC chiến dịch ngày hôm nay',
      cpc_campaign_yesterday: 'Phần trăm của CPC chiến dịch ngày hôm qua',
      cpc_campaign_week: 'Phần trăm của CPC chiến dịch 7 ngày qua',
      cpc_campaign_month: 'Phần trăm của CPC chiến dịch 30 ngày qua',
      cpc_shop_today: 'Phần trăm của CPC shop ngày hôm nay',
      cpc_shop_yesterday: 'Phần trăm của CPC shop ngày hôm qua',
      cpc_shop_week: 'Phần trăm của CPC shop 7 ngày qua',
      cpc_shop_month: 'Phần trăm của CPC shop 30 ngày qua',
      add_search_keyword: 'Thêm lệnh tìm kiếm trong báo cáo',
    },
    create_shop_flash_sale: 'Tạo Flash sale của shop',
    create_shop_vouchers: 'Tạo Voucher của shop',
    auto_budget: 'Ngân sách tự động',
    update_budget_confirm: 'Bạn có chắc chắn muốn cập nhật ngân sách quảng cáo không?',
    error_with_exporting: 'Đã có lỗi khi tải báo cáo',
    error_with_exporting_21: 'Đã có lỗi khi tải báo cáo 2.1',
    error_with_exporting_22: 'Đã có lỗi khi tải báo cáo 2.2',
    error_with_getting_products: 'Đã có lỗi khi tải dữ liệu sản phẩm',
    error_with_getting_campaigns: 'Đã có lỗi khi lấy danh sách chiến dịch',
    error_with_getting_campaign_detail: 'Đã có lỗi xảy ra trong quá trình lấy thông tin chiến dịch',
    error_with_creating_campaign: 'Đã có lỗi khi tạo chiến dịch',
    error_with_add_keywords: 'Đã có lỗi khi thêm từ khóa',
    just_select_only_one_1: 'Bạn chỉ có thể sử dụng 1 trong số các cấu hình tự động. Nếu bạn chọn cấu hình tối ưu theo CIR tự động thì các cấu hình khác sẽ bị xóa hoặc tạm dừng (ngoại trừ Chống click ảo). Bạn có muốn tiếp tục?',
    just_select_only_one_2: 'Bạn chỉ có thể sử dụng 1 trong số các cấu hình tự động. Nếu bạn chọn cấu hình đấu thầu tự động thì các cấu hình khác sẽ bị xóa hoặc tạm dừng (ngoại trừ Chống click ảo). Bạn có muốn tiếp tục?',
    just_select_only_one_3: 'Bạn chỉ có thể sử dụng 1 trong số các cấu hình tự động. Nếu bạn chọn cấu hình duy trì vị trí tự động thì các cấu hình khác sẽ bị xóa hoặc tạm dừng (ngoại trừ Chống click ảo). Bạn có muốn tiếp tục?',
    enable_target_roas: 'Bật tối đa doanh thu',
    maximise_gmv_potential_by: 'Tối đa hóa tiềm năng phát triển Doanh thu bằng cách tận dụng toàn bộ lưu lượng trên nền tảng Shopee.',
    set_your_own_roas_target: 'Tự thiết lập Mục tiêu ROAS',
    better_competitiveness_than_x: 'Cạnh tranh hiển thị tốt hơn {x}% chiến dịch tương tự',
    ecpc_shopee_message: ' Nếu eCPC được kích hoạt, chênh lệch giá thầu thực tế cho mỗi lượt nhấp chuột sẽ được tối ưu dựa trên khả năng chuyển đổi: tăng giá thầu khi đạt chuyển đổi cao và giảm giá thầu khi đạt chuyển đổi thấp. Tuy nhiên, Shopee đảm bảo rằng giá thầu trung bình hàng ngày cho mỗi lượt nhấp chuột sẽ gần với giá thầu mà bạn đã đặt.',
    not_creating_search_ads_manual: 'Chưa tạo quảng cáo Tìm kiếm thủ công',
    not_creating_search_ads_auto: 'Chưa tạo quảng cáo Tìm kiếm tự động',
    not_creating_discover_ads_manual: 'Chưa tạo quảng cáo Khám phá thủ công',
    not_creating_discover_ads_auto: 'Chưa tạo quảng cáo Khám phá tự động',
    not_creating_all_ads_manual: 'Chưa tạo quảng cáo Tất cả thủ công',
    not_creating_all_ads_auto: 'Chưa tạo quảng cáo Tất cả tự động',
    atosa_balance_running_low: 'Số dư tài khoản Atosa của bạn đang thấp, điều này có thể làm ảnh hưởng tới các cấu hình tự động đang thu phí hàng ngày.',
    atosa_balance_running_low_recharge: 'Nạp tiền ngay.',
    fee_collection_notice: 'Thông báo thu phí tính năng',
    dear_customer: 'Kính gửi quý khách hàng',
    first_line: 'Trước tiên, chúng tôi xin chân thành cảm ơn Quý khách đã tin tưởng và sử dụng phần mềm Atosa của chúng tôi trong thời gian qua. Chúng tôi luôn cam kết mang lại những tính năng và dịch vụ tốt nhất để hỗ trợ Quý khách trong công việc',
    second_line: 'Chúng tôi xin thông báo về việc thu phí sử dụng các tính năng của phần mềm trong khoảng thời gian từ ngày 01/10/2024 trở đi. Chi tiết các tính năng và công thức tính phí cụ thể như sau',
    third_line: 'Chúng tôi rất mong nhận được sự ủng hộ và hợp tác từ Quý khách hàng để phát triển cùng nhau. Trân trọng cảm ơn!',
    fourth_line: 'Một lần nữa, chúng tôi xin cảm ơn Quý khách đã luôn đồng hành cùng Atosa',
    fifth_line: 'Trân trọng!',
    read_and_confirm: 'Tôi đã đọc và đồng ý với thông báo trên',
    do_not_show_notification_again: 'Không hiển thị lại thông báo',
    do_not_show_again: 'Không hiển thị lại',
    operation_history: 'Lịch sử hoạt động',
    connect_erp_platform: 'Kết Nối Hệ Thống Atosa ERP Platform',
    connect_ads_platform: 'Kết Nối Hệ Thống Atosa Ads Platform',
    gmv_max: 'Tối đa Doanh thu',
    auto_bidding_standard: 'Giá thầu tự động',
    surge_tool_tip: 'Vào ngày khuyến mãi lớn, giá thầu từ khóa thủ công sẽ được Shopee tối ưu trong 24 giờ để có lưu lượng truy cập rộng hơn nhằm tối đa hóa doanh thu và đảm bảo chi phí không vượt quá ngân sách bạn đã đặt. Nhấn vào "Cài đặt cấp độ Shop" để tắt/bật tính năng Tối Ưu Hóa Giá Đấu Thầu Ngày Sale.',
    connect_erp_platform_tool_tip: 'Hãy kết nối với nền tảng để trải nghiệm các tính năng và dịch vụ nâng cao. Hệ thống có thể tính toán được GMV Hủy và ROAS Hủy.',
    connect_ads_platform_tool_tip: 'Hãy kết nối với nền tảng để trải nghiệm các tính năng và dịch vụ nâng cao.',
    each_5_minutes_on_flash_sale_day: 'Chạy quy tắc 5 phút một lần vào ngày Flash Sale và chạy từ 0h00p đến 2h00p.',
    setup_auto_config: 'Cài đặt cấu hình tự động',
    mass_adjust: 'Điều chỉnh hàng loạt',
    duplicated_campaigns: 'Chiến dịch bị trùng',
    advanced_auto_condition_action_note: 'Chạy quy tắc 3 phút một lần từ 0 giờ đến 1 giờ theo ngày chỉ định.',
    advanced_auto_condition_action_note_2: 'Chạy quy tắc 10 phút một lần theo khung thời gian chỉ định.',
    advanced_auto_condition_action_note_3: 'Chạy quy tắc 15 phút một lần theo khung thời gian chỉ định.',
    auto_all_ads_standard: 'Quảng cáo tất cả tự động - Tiêu chuẩn',
    auto_search_ads_standard: 'Quảng cáo tìm kiếm tự động - Tiêu chuẩn',
    auto_targeting_ads_standard: 'Quảng cáo khám phá tự động - Tiêu chuẩn',
    gmv_max_auto: 'Quảng cáo Tối đa Doanh thu - Tự động',
    gmv_max_custom: 'Quảng cáo Tối đa Doanh thu - Tùy chỉnh',
    all_gmv_max_auto: 'Quảng cáo tất cả Tối đa Doanh thu - Tự động',
    all_gmv_max_custom: 'Quảng cáo tất cả Tối đa Doanh thu - Tùy chỉnh',
    search_gmv_max_auto: 'Quảng cáo tìm kiếm Tối đa Doanh thu - Tự động',
    search_gmv_max_custom: 'Quảng cáo tìm kiếm Tối đa Doanh thu - Tùy chỉnh',
    targeting_gmv_max_auto: 'Quảng cáo khám phá Tối đa Doanh thu - Tự động',
    targeting_gmv_max_custom: 'Quảng cáo khám phá Tối đa Doanh thu - Tùy chỉnh',
    gmv_max_auto_title: 'Tối đa Doanh thu Tối ưu ROAS bởi Hệ thống',
    gmv_max_auto_description: 'Shopee sẽ liên tục tối ưu Quảng cáo để đạt mức ROAS ổn định. ',
    gmv_max_custom_title: 'Tối đa Doanh thu Tùy chỉnh ROAS',
    gmv_max_custom_description: 'Tự thiết lập Mục tiêu ROAS',
    search_within_all: 'Quảng cáo tất cả - Chỉ vị trí tìm kiếm',
    discovery_within_all: 'Quảng cáo tất cả - Chỉ vị trí khám phá',
    discovery: 'Khám phá',
    create_product_ads: 'Tạo quảng cáo sản phẩm',
    keyword_cpc_past7days: 'CPC của từ khóa 7 ngày qua',
    keyword_cpc_past30days: 'CPC của từ khóa 30 ngày qua',
    keyword_cpc_optional: 'CPC của từ khóa (tùy chọn)',
    campaign_cpc_past7days: 'CPC của chiến dịch 7 ngày qua',
    campaign_cpc_past30days: 'CPC của chiến dịch 30 ngày qua',
    campaign_cpc_optional: 'CPC của chiến dịch (tùy chọn)',
    ad_cpc_past7days: 'CPC của quảng cáo 7 ngày qua',
    ad_cpc_past30days: 'CPC của quản cáo 30 ngày qua',
    ad_cpc_optional: 'CPC của quảng cáo (tùy chọn)',
    use_realtime_cost: 'Sử dụng chi phí hiện tại',
    gmv_max_auto_short: 'Tối đa Doanh thu - Tự động',
    gmv_max_custom_short: 'Tối đa Doanh thu - Tùy chỉnh',
    not_creating_roi_two_ads: 'Chưa tạo quảng cáo Tối đa Doanh thu',
    optimize_keyword_based_on_cir: 'Tối ưu CIR từ khóa',
    optimize_targeting_based_on_cir: 'Tối ưu CIR khám phá',
    vit_ads_keyword: 'Vít ads từ khóa',
    vit_ads_targeting: 'Vít ads khám phá',
    live_stream: 'Quảng cáo Livestream',
    get_cir_by: 'Lấy tỉ lệ CIR (ACOS) theo khoảng thời gian',
    convert_from_all_to_search: 'Chuyển Quảng cáo Tất cả thủ công sang Quảng cáo Tìm kiếm thủ công',
    convert_from_all_to_discovery: 'Chuyển Quảng cáo Tất cả thủ công sang Quảng cáo Khám phá thủ công',
    processing_convert_ads_message: 'Hệ thống đang chuyển đổi quảng cáo, vui lòng đợi trong giây lát...',
    create_separate_ads: 'Tạo riêng các quảng cáo',
    create_separate_ads_message: 'Hệ thống sẽ tạo riêng Quảng cáo tìm kiếm và Quảng cáo khám phá cho từng sản phẩm.',
    always_ongoing: 'Luôn bật chiến dịch',
    always_ongoing_message: 'Hệ thống sẽ luôn bật chiến dịch để tránh chiến dịch bị dừng không rõ nguyên nhân, gây ảnh hưởng tới hiệu quả của chiến dịch.',
    campaign_name_already_exists: 'Trùng tên với chiến dịch Quảng cáo Shop đang có. Vui lòng nhập tên khác.',
    event_type: {
      label: 'Loại sự kiện',
      campaign_creation: 'Tạo quảng cáo', // parent
      campaign_status_change: 'Thay đổi trạng thái quảng cáo', // parent
      pause_ad: 'Tạm dừng quảng cáo',
      resume_ad: 'Tiếp tục quảng cáo',
      start_ad: 'Bắt đầu quảng cáo',
      stop_ad: 'Dừng quảng cáo',
      restart_ad: 'Khởi động lại quảng cáo',
      delete_ad: 'Xóa quảng cáo',
      campaign_setting_change: 'Thay đổi cài đặt quảng cáo', // parent
      change_schedule: 'Thay đổi thời gian',
      change_target_roas: 'Thay đổi Mục tiêu ROAS',
      change_placement: 'Thay đổi Vị trí',
      update_target_audience: 'Cập nhật Đối tượng mục tiêu',
      change_bidding_method: 'Thay đổi phương thức đặt giá thầu',
      billing_mode_switch: 'Đổi chế độ thanh toán',
      campaign_budget_change: 'Thay đổi ngân sách quảng cáo', // parent
      change_budget: 'Thay đổi ngân sách',
      creative_change: 'Thay đổi nội dung quảng cáo', // parent
      update_creative: 'Cập nhật nội dung quảng cáo',
      keyword_change: 'Thay đổi từ khóa', // parent
      update_keywords: 'Cập nhật từ khóa',
      toggle_change: 'Thay đổi cài đặt', // parent
      new_product_boost: 'Tăng hiển thị cho sản phẩm mới',
      enhanced_bid_price: 'Giá thầu cạnh tranh',
      creative: 'Nội dung quảng cáo',
    },

  }, // todo: end ads

  create_ads: {
    auto_bidding: 'Tự động',
    manual_bidding: 'Tùy chỉnh',
    custom: 'Tùy chọn một giá trị',
    auto_bidding_message: 'Shopee sẽ liên tục tối ưu Quảng cáo để đạt mức ROAS ổn định.',
    let_shopee_audience: 'Hãy để Shopee giúp quảng cáo của bạn tiếp cận đúng người mua tiềm năng.',
    prioritise_specific: 'Ưu tiên hiển thị quảng cáo tới người mua nằm trong tệp đối tượng bạn tùy chỉnh.',
  },

  day: {
    flash_sale: 'Ngày Flash Sale',
    before_flash_sale: 'Trước ngày Flash Sale',
    after_flash_sale: 'Sau ngày Flash Sale',
    mini_spike_day: 'Ngày Mini Spike',
    specific_day: 'Ngày cụ thể',
    remaining_days: 'Ngày còn lại',
    past3days: '3 ngày qua',
    past5days: '3 ngày qua',
    past7days: '1 tuần qua',
    past14days: '2 tuần qua',
    past21days: '3 tuần qua',
    past30days: '1 tháng qua',
    past60days: '2 tháng qua',
    past90days: '3 tháng qua',
    from_start_month: 'Từ đầu tháng',
    range: 'Khoảng thời gian',
    realtime: 'Thời gian hiện tại',
    daily: 'Hàng ngày',
    before_flash_sale_x_days: 'Trước ngày Flash Sale {x} ngày',
    after_flash_sale_x_days: 'Sau ngày Flash Sale {x} ngày',
    the_x_of_every_month: 'Ngày {x} hàng tháng',
    from_to: 'Từ ngày đến ngày',
    every_day: 'Chạy hàng ngày',
    every_week: 'Chạy hàng tuần',
    every_month: 'Chạy hàng tháng',
    from: 'Từ ngày',
    to: 'đến',
    monday: 'Thứ hai',
    tuesday: 'Thứ ba',
    wednesday: 'Thứ tư',
    thursday: 'Thứ năm',
    friday: 'Thứ sáu',
    saturday: 'Thứ bảy',
    sunday: 'Chủ nhật',
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    normal: 'Ngày thường',
    spike: 'Ngày sale',
    exclude_sale: 'Ngoại trừ ngày sale',
    from_x_to_y: 'Từ ngày {x} đến ngày {y}',
    after_every: 'Chạy lại sau',
    after_x_days: 'Chạy lại sau {x} ngày',
    past_x_hours: '{x} tiếng qua',
  }, // todo: end day

  metric: {
    average_ranking: 'Thứ hạng TB',
    impressions: 'Số lượt xem',
    clicks: 'Số lượt click',
    ctr: 'Tỷ lệ click',
    conversions: 'Lượt chuyển đổi',
    direct_conversions: 'Lượt chuyển đổi trực tiếp',
    items_sold: 'Sản phẩm đã bán',
    direct_items_sold: 'Sản phẩm đã bán trực tiếp',
    broad_gmv: 'GMV',
    direct_gmv: 'GMV trực tiếp',
    expense: 'Chi phí',
    broad_roi: 'ROI (ROAS)',
    direct_roi: 'ROI (ROAS) trực tiếp',
    broad_cir: 'CIR (ACOS)',
    direct_cir: 'CIR (ACOS) trực tiếp',
    conversion_rate: 'Tỷ lệ chuyển đổi',
    direct_conversion_rate: 'Tỷ lệ chuyển đổi trực tiếp',
    cost_per_conversion: 'Chi phí chuyển đổi',
    cost_per_direct_conversion: 'Chi phí chuyển đổi trực tiếp',
    shop_impressions: 'Lượt xem shop',
    shop_clicks: 'Lượt click shop',
    shop_ctr: 'Tỷ lệ click shop',
    product_impressions: 'Lượt xem SP',
    product_clicks: 'Lượt click SP',
    product_ctr: 'Tỷ lệ click SP',
    plan: 'Kế hoạch',
    complete: 'Hoàn thành',
    add_to_cart_units: 'Lượt bỏ giỏ',
    add_to_cart_buyers: 'Số khách bỏ giỏ',
    orders: 'Đơn hàng',
    ads_orders: 'Đơn hàng Ads',
    ads_expense: 'Chi phí Ads',
    total_sold: 'Tổng đã bán',
    voucher_expense: 'Chi phí voucher',
    voucher_usage: 'Lượt sử dụng voucher',
    sales: 'Doanh số',
    sales_per_buyer: 'Doanh số trên mỗi người mua',
    gmv_ads: 'GMV Ads',
    cost_ads: 'Chi phí Ads',
    order_ads: 'Đơn hàng Ads',
    gmv: 'GMV',
    cir: 'CIR',
    roas: 'ROAS',
    users_views: 'Số khách truy cập SP',
    checkout: 'Số đơn hàng',
    past7days: 'Chỉ số 7 ngày qua',
    past30days: 'Chỉ số 30 ngày qua',
    avg_gmv: 'GMV trung bình',
    cost: 'Chi phí',
    impression: 'Lượt xem',
    click: 'Lượt click',
    cpc: 'CPC',
    cr: 'Tỷ lệ chuyển đổi',
    daily_budget: 'Ngân sách ngày',
    target_roas: 'Mục tiêu ROAS',
    avg_rank: 'Thứ hạng TB',
    cancelled_gmv: 'GMV Hủy',
    cancelled_roi: 'ROI (ROAS) Hủy',
    exclude_cancelled_gmv: 'GMV đã trừ hủy',
    exclude_cancelled_roi: 'ROI (ROAS) đã trừ hủy',
  }, // todo: end metric

  keyword: {
    all: 'Tất cả từ khóa',
    exact: 'Từ khóa chính xác',
    broad: 'Từ khóa mở rộng',
    saved_files: 'File từ khóa đã lưu',
    limit_message: 'Số lần tìm kiếm và số lượng từ khóa trả về đang bị giới hạn. Vui lòng nâng cấp gói để xem toàn bộ dữ liệu. Số lượt tìm kiếm còn lại',
    show_current_keyword: 'Hiển thị từ khóa hiện tại',
    open_current_keyword: 'Mở từ khóa hiện tại',
    save_file: 'Lưu file từ khóa',
    save_selected: 'Lưu từ khóa đã chọn',
    save_all: 'Lưu tất cả từ khóa',
    has_no_keyword: 'Chưa có từ khóa nào, hay thêm từ khóa của bạn',
    add_keywords: 'Thêm từ khóa',
    has_no_connected_message: 'Chưa kết nối đến tài khoản người bán kênh Shopee, vui lòng chọn 1 tài khoản khác và thử lại',
    file: 'File từ khóa',
    empty_to_save: 'Bạn chưa có từ khóa nào, hãy thêm từ khóa để lưu!',
    confirm_save_file_x_name: 'Bạn có chắc muốn lưu tệp từ khóa với tên {x} không?',
    chart_message: 'Biểu đồ thể hiện lượt kiếm của từ khóa trên các thiết bị',
    enter_keyword_analysis: 'Nhập từ khóa để phân tích',
    select_product: 'Chọn sản phẩm tìm kiếm',
    research_keyword: 'Phân tích từ khóa',
    total_shopee_volume: 'Tổng lượt tìm kiếm Shopee',
    getting_shopee_data: 'Đang lấy dữ liệu từ Shopee',
    updated_shopee_data: 'Đã cập nhật Lượt tìm kiếm và Giá thầu của Shopee',
    can_not_connect: 'Không thể kết nối đến tài khoản, vui lòng kiểm kiểm tra và thử lại sau!',
    error_while_get_data: 'Có lỗi trong quá trình lấy dữ liệu, vui lòng kiểm tra và thử lại sau!',
    result_not_found_message: 'Không tìm thấy kết quả cho từ khóa {x} trên hệ thống Atosa. Đã bổ sung kết quả tìm kiếm từ Shopee',
    start_getting_shopee_data: 'Bắt đầu lấy dữ liệu trên Shopee',
    import_note: 'Hãy lưu từ khóa ở cột đầu tiên, giá thầu ở cột thứ hai (Giá thầu không bắt buộc)',
    add_all: 'Thêm tất cả từ khóa',
    add_top_x: 'Thêm {x} từ khóa đầu tiên',
    confirm_and_add: 'Xác nhận và thêm từ khóa',
    added_keywords: 'Từ khóa đã thêm',
    pause: 'Tạm dừng từ khóa',
    type: 'Loại từ khóa',
    report: 'Báo cáo từ khóa',
    word_count: 'Số lượng từ của từ khóa',
    with_very_low_performance: 'Từ khóa hiệu quả rất thấp',
    with_low_performance: 'Từ khóa hiệu quả thấp',
    with_average_performance: 'Từ khóa hiệu quả trung bình',
    with_high_performance: 'Từ khóa hiệu quả cao',
    report_analysis: 'Phân tích báo cáo từ khóa',
    update_existed_file: 'Cập nhật file từ khóa đã lưu',
    cannot_delete_all_keywords: 'Không thể xóa tất cả từ khóa! Bạn phải để lại ít nhất 1 từ khóa',
    delete_confirm: 'Bạn có muốn xóa từ khóa các từ khóa đã chọn không? Hiện tại Shopee đã loại bỏ tính năng xóa từ khóa, các từ khóa bị xóa sẽ chuyển về trạng thái tạm dừng. Lưu ý chiến dịch sẽ phải chuyển về trạng thái kết thúc để xóa từ khóa!',
    delete_x_confirm: 'Bạn có muốn xóa từ khóa "{x}" không? Hiện tại Shopee đã loại bỏ tính năng xóa từ khóa, các từ khóa bị xóa sẽ chuyển về trạng thái tạm dừng. Lưu ý chiến dịch sẽ phải chuyển về trạng thái kết thúc để xóa từ khóa!',
    not_found: 'Không tìm thấy từ khóa nào',
    dont_use_restricted: 'Không sử dụng từ khóa bị hạn chế',
    add_to_campaigns: 'Thêm từ khóa vào chiến dịch',
    match_to_original_keyword: 'Khớp với từ khóa gốc',
    not_match_to_original_keyword: 'Không khớp với từ khóa gốc',
    existing_in_campaign: 'Đã có trong chiến dịch',
    not_existing_in_campaign: 'Chưa có trong chiến dịch',
    existed: 'Đã có từ khóa',
    not_existed: 'Chưa có từ khóa',
    file_list: 'Danh sách file từ khóa',
    keyword_number: 'Số lượng từ khóa',
    not_files: 'Chưa có tệp hoặc không có tệp phù hợp',
    list: 'Danh sách từ khóa',
    volume_at_saving: 'Lượt tìm kiếm khi lưu',
    bid_price_at_saving: 'Giá thầu khi lưu',
    current_volume: 'Lượt tìm kiếm hiện tại',
    current_bid_price: 'Giá thầu hiện tại',
    your_bid_price: 'Giá thầu của bạn',
    update_note: 'Thay đổi của bạn chỉ là tạm thời, hãy nhấn lưu để cập nhật dữ liệu trên Atosa',
    add_to_current_keyword: 'Thêm vào [Từ khóa hiện tại]',
    update_file_confirm: 'Bạn có chắc muốn cập nhật tệp từ khóa này không?',
    can_not_connect_fff: 'Không thể kết nối đến tài khoản, vui lòng kiểm tra và thử lại sau!',
  }, // todo: end keyword

  product: {
    get_success: 'Lấy dữ liệu sản phẩm thành công',
    list: 'Danh sách sản phẩm',
    change_name_note: 'Lưu ý: Sử dụng tính năng xem trước để kiểm tra tên hoặc ảnh của sản phẩm trước khi cập nhật hàng loạt!',
    add_to_group: 'Thêm sản phẩm vào nhóm',
    remove_from_group: 'Xóa sản phẩm khỏi nhóm',
    restricted_keywords_file: 'Danh sách file từ khóa bị hạn chế',
    add_restricted_keywords_file: 'Thêm file từ khóa bị hạn chế',
    update_restricted_keywords_file: 'Cập nhật từ khóa của tệp',
    add_restricted_keywords: 'Thêm từ khóa bị hạn chế',
    delete_restricted_keywords: 'Xóa từ khóa bị hạn chế',
    group: 'Nhóm sản phẩm',
    group_list: 'Danh sách nhóm sản phẩm',
    add_group: 'Thêm nhóm sản phẩm',
    group_name: 'Tên nhóm',
    restricted_keywords: 'Từ khóa bị hạn chế',
    preview_products: 'Xem trước sản phẩm',
    mass_add_text: 'Thêm text hàng loạt',
    mass_remove_text: 'Xoá text hàng loạt',
    before_name: 'Phía trước tên sản phẩm',
    after_name: 'Phía sau tên sản phẩm',
    text_insert_position: 'Vị trí thêm',
    skip_products_preview: 'Bỏ qua xem trước',
    mass_edit_name: 'Sửa tên sản phẩm hàng loạt',
    add_text: 'Thêm text trong Tên sản phẩm',
    replace_text: 'Thay thế text trong Tên sản phẩm',
    remove_text: 'Xóa text trong Tên sản phẩm',
    mass_add_frame: 'Thêm khung ảnh hàng loạt',
    mass_remove_frame: 'Xóa khung ảnh hàng loạt',
    id: 'Mã SP',
    edit_name: 'Đổi tên sản phẩm',
    edit_cover_image: 'Thay ảnh bìa',
    add_frame: 'Thêm khung ảnh',
    history_edit_name: 'Lịch sử đổi tên',
    history_edit_image: 'Lịch sử thay ảnh',
    history_edit_name_of: 'Lịch sử đổi tên của sản phẩm',
    history_edit_image_of: 'Lịch sử thay ảnh của sản phẩm',
    input_remove_text: 'Nhập đoạn text muốn loại bỏ',
    uppercase_letter: 'Phân biệt chữ hoa',
    remove_only_once: 'Chỉ xóa 1 lần',
    edit_product_cover_image: 'Thay ảnh bìa cho sản phẩm',
    add_frame_product_image: 'Thêm khung ảnh cho sản phẩm',
    edit_product_cover_image_note: 'Lưu ý: Trước khi thay đổi ảnh bìa cần lưu lại ảnh gốc. Nếu cần khôi phục, bạn có thể tải lại ảnh gốc khi chỉnh sửa sản phẩm.',
    drag_and_drop_image: 'Kéo ảnh vào đây hoặc',
    click_to_upload: 'click để upload',
    required_image_format: 'Yêu cầu định dạng jpg/png',
    old_image: 'Ảnh cũ',
    new_image: 'Ảnh mới',
    use_other_image: 'Sử dụng ảnh khác',
    use_other_frame: 'Sử dụng khung ảnh khác',
    confirm_edit_cover: 'Xác nhận thay ảnh bìa',
    attention_1: 'Trước khi thay đổi ảnh bìa cần lưu lại ảnh gốc. Nếu cần khôi phục, bạn có thể tải lại ảnh gốc khi chỉnh sửa sản phẩm.',
    attention_2: 'Sử dụng các file có định dạng .png làm khung ảnh.',
    attention_3: 'Tải các mẫu ảnh bìa khác',
    edit_cover_image_only: 'Chỉ sửa ảnh bìa',
    apply_for_multiple_images: 'Áp dụng cho nhiều ảnh',
    all_frames: 'Tất cả khung ảnh',
    frames_for_spike_day: 'Khung ảnh cho ngày Flash Sale',
    upload_frames: 'Tải khung ảnh lên',
    check_other_frames: 'Tham khảo khung ảnh khác',
    select_image_to_add_frames: 'Chọn ảnh để thêm khung',
    adding_frame: 'Đang chèn khung ảnh',
    confirm_add_frame: 'Xác nhận thêm khung ảnh',
    recover_images: 'Khôi phục ảnh',
    remove_frame: 'Xóa khung ảnh',
    recover_cover_image: 'Khôi phục ảnh bìa',
    recover_old_image: 'Khôi phục ảnh cũ',
    current_name: 'Tên sản phẩm hiện tại',
    new_name: 'Tên sản phẩm mới',
    replace_first_only: 'Chỉ thay thế đoạn text được tìm thấy đầu tiên',
    replace_with: 'Thay thế bằng',
    expected_replace_text: 'Đoạn text muốn thay thế',
    change_name: 'Đổi tên sản phẩm',
    recover_old_name: 'Khôi phục tên sản phẩm cũ',
    old_name: 'Têm sản phẩm cũ',
    current_cover_image: 'Ảnh bìa hiện tại',
    cover_image_after_remove_frame: 'Ảnh bìa sau khi xóa khung',
    delete_frame_confirm: 'Bạn có chắc chắn muốn xóa khung ảnh không?`',
    delete_frame_success: 'Xóa khung ảnh thành công',
    recover_old_name_confirm: 'Bạn có chắc chắn muốn khôi phục tên sản phẩm cũ không?',
    recover_old_image_confirm: 'Bạn có chắc chắn muốn khôi phục ảnh cũ không?',
    change_name_confirm: 'Bạn có chắc chắn muốn đổi tên sản phẩm không?',
    cannot_recover_old_image: 'Không thể khôi phục ảnh gốc của sản phẩm này',
    recover_image_success: 'Khôi phục ảnh thành công',
    updated_time: 'Thời điểm cập nhật',
    current_time: 'Thời điểm cập nhật',
    add_frame_confirm: 'Bạn có chắc chắn muốn thêm khung ảnh cho sản phẩm không?',
    edit_cover_image_confirm: 'Bạn có chắc chắn muốn thay ảnh bìa cho sản phẩm không?',
    process_adding_frame_complete: 'Đã thực hiện xong quá trình thêm khung ảnh',
    error_with_adding_frame: 'Đã có lỗi trong quá trình thêm khung ảnh',
    update_cover_image_success: 'Cập nhật ảnh bìa thành công',
    delete_group_confirm: 'Bạn có chắc chắn muốn xóa nhóm sản phẩm không?',
    delete_product_from_file_confirm: 'Bạn có chắc chắn muốn xóa sản phẩm này ra khỏi file không?',
    delete_product_from_group_confirm: 'Bạn có chắc chắn muốn xóa sản phẩm này ra khỏi nhóm không?',
    name_too_long: 'Lỗi: Tên sản phẩm quá dài',
    all: 'Tất cả sản phẩm',
    select_multiple: 'Chọn nhiều sản phẩm',
    current_list: 'Danh sách sản phẩm đang hiển thị',
    name: 'Tên SP',
    model_id: 'Mã phân loại',
    model_name: 'Tên phân loại',
    original_price: 'Giá bán gốc',
    current_price: 'Giá bán hiện tại',
    stock: 'Tồn kho',
    flash_sale_price: 'Giá bán Flash Sale',
    promotion_quantity: 'Số lượng khuyến mãi',
    limit: 'Giới hạn',
    download_file_success: 'Tải file sản phẩm thành công',
    type: 'Loại sản phẩm',
    after_x_character: 'Phía sau từ thứ {x} của tên sản phẩm',
  }, // todo: end product

  planning: {
    gmv: 'Kế hoạch GMV',
    cost: 'Kế hoạch chi phí',
    order: 'Kế hoạch đơn hàng',
    traffic: 'Kế hoạch traffic',
    cir: 'Kế hoạch CIR',
    roas: 'Kế hoạch ROAS',
  }, // todo: end planning,

  center: {
    go_to_shopee_ads: 'Di chuyển tới Quảng cáo Shopee',
    use_cost_ads: 'Sử dụng chi phí quảng cáo',
    placed_order: 'Đơn hàng đã đặt',
    confirmed_order: 'Đơn hàng đã xác nhận',
    paid_order: 'Đơn hàng đã thanh toán',
    sales: 'Doanh thu',
    orders: 'Đơn hàng',
    conversions_rate: 'Tỷ lệ chuyển đổi',
    sales_on_orders: 'Doanh thu / đơn',
    visitor: 'Lượt truy cập',
    page_views: 'Lượt xem trang',
    aov: 'Trung bình đơn',
    customer_segment: 'Phân khúc Khách hàng theo giá trị mua',
    pricing_segment: 'Phân khúc giá',
    add_to_cart_rate_on_view: '% bỏ giỏ / lượt xem',
    placed_units_all: 'Lượt bán (Tất cả đơn)',
    placed_units_placed: 'Lượt bán (Đơn đã đặt)',
    placed_units_confirmed: 'Lượt bán (Đơn đã xác nhận)',
    placed_units_paid: 'Lượt bán (Đơn đã thanh toán)',
    placed_units_on_add_to_cart_units_rate: '% lượt bán / bỏ giỏ',
    placed_units_on_add_add_to_cart_buyers_rate: '% lượt bán / khách bỏ giỏ',
    sales_all: 'Doanh thu (Tất cả đơn)',
    sales_placed: 'Doanh thu (Đơn đã đặt)',
    sales_confirmed: 'Doanh thu (Đơn đã xác nhận)',
    sales_paid: 'Doanh thu (Đơn đã thanh toán)',
    today_until_x: 'Tới {x} giờ hôm nay',
    vs_x_yesterday: 'so với {x} hôm qua',
    vs_previous_day: 'so với ngày hôm trước',
    vs_7_days: 'so với 7 ngày trước',
    vs_30_days: 'so với 30 ngày trước',
    by_day: 'Theo ngày',
    by_week: 'Theo tuần',
    by_month: 'Theo tháng',
    by_year: 'Theo năm',
    vs_previous_week: 'so với tuần trước',
    vs_previous_month: 'so với tháng trước',
    vs_previous_year: 'so với năm trước',
    past7days: 'Trong 7 ngày qua',
    past3days: 'Trong 30 ngày qua',
    cannot_show_chart: 'Không thể hiển thị biểu đồ do dữ liệu quá lớn. Tính năng đang được cập nhật',
    cancel_order_rate: 'Tỉ lệ đơn không thành công',
    improve_conversions_rate: 'Shop ơi, hãy cải thiện lượt chuyển đổi nhé',
    chat_response_rate: 'Tỉ lệ phản hồi chat',
    shop_rating: 'Đánh giá shop',
    ratings: 'đánh giá',
    should_respond_chat: 'Shop nên phản hồi chat tích cực hơn nhé',
    ask_for_positive: 'Shop ơi, hãy xin đánh giá tốt của KH để thu hút sản phẩm hơn hơn',
    response_time: 'Thời gian phản hồi',
    respond_customers_faster: 'Hãy trả lời KH nhanh hơn shop nhé',
    improvable: 'Có thể cải thiện',
    high_quality: 'Chất lượng đăng bán tốt',
    more_x_products_need_to_improve: 'Hơn {x}% sản phẩm cần được cải thiện',
    very_good: 'Rất tốt! Shop của bạn không có sản phẩm nào cần cải thiện',
    note_1: 'Chất lượng đăng bán của nhiều sản phẩm của Shop đang được gợi ý để cải thiện. Chất lượng đăng bán tốt sẽ thu hút người mua và tăng độ cạnh tranh hiển thị.',
    note_2: 'Hãy xem qua một vài ví dụ sản phẩm có chất lượng đăng bán tốt và gợi ý cải thiện bên dưới nhé.',
    note_3: 'Hãy cập nhật sản phẩm theo gợi ý ở bên dưới nhé shop',
    product_tab_1: 'Tên sản phẩm còn ngắn',
    product_tab_2: 'Mô tả còn ngắn',
    product_tab_3: 'Sai ngành hàng',
    product_tab_4: 'Hình ảnh còn ít',
    product_tab_5: 'Thiếu thông tin kích thước',
    suggest_seo_name: 'Gợi ý Tên chuẩn SEO',
    update_by_suggested: 'Cập nhật theo gợi ý',
    last_updated: 'Cập nhật lần cuối',
    recommend: 'Đề xuất',
    update_by_same_category: 'Cập nhật ngành hàng tương ứng',
    edit_size: 'Điền kích thước kiện hàng',
    campaigns_effectiveness: 'Hiệu quả chiến dịch',
    ads_effectiveness: 'Hiệu quả quảng cáo',
    ongoing_campaigns: 'Số chiến dịch đang chạy',
    ongoing_campaigns_with_daily_budget: 'Số chiến dịch đang chạy với ngân sách hàng ngày',
    ongoing_campaigns_with_total_budget: 'Số chiến dịch đang chạy với ngân sách tổng',
    sum_daily_budget: 'Tổng ngân sách hàng ngày',
    sum_total_budget: 'Tổng ngân sách tổng',
    optimize_or_pause_campaigns_note: 'Cân nhắc việc Tối Ưu Quảng Cáo hoặc Tạm dừng các chương trình quảng cáo không hiệu quả bên dưới shop nhé.',
    campaigns_with_low_performance: 'Danh sách Chiến dịch quảng cáo có hiệu quả thấp',
    within_few_hours: 'Trong vòng vài giờ',
    flash_sale_report: 'Báo cáo dữ liệu ngày Flash Sale',
    add_to_cart_units_pv: 'Tỷ lệ SP bỏ giỏ/ lượt xem trang',
    add_to_cart_buyers_pv: 'Tỷ lệ Khách bỏ giỏ/ lượt xem trang',
    confirmed_units_add_to_cart_units: 'Tỷ lệ SP đơn xác nhận / bỏ giỏ',
    confirmed_units_add_to_cart_buyers: 'Tỷ lệ SP đơn xác nhận / khách bỏ giỏ',
    product_conversion_report: 'Báo cáo dữ liệu chuyển đổi của sản phẩm',
    confirmed_buyers_placed_buyers: 'Tỷ lệ KH đơn xác nhận/ đơn đặt',
    uv_pv: 'Tỷ lệ lượt truy cập/ lượt xem trang sản phẩm',
    atc_uv_uv: 'Tỷ lệ KH bỏ giỏ/ lượt truy cập',
    placed_buyers_atc_uv: 'Tỷ lệ KH đặt đơn/ bỏ giỏ',
    atc_unit_num_atc_uv: 'Tỷ lệ sản phẩm bỏ giỏ trên 1 KH',
    placed_unit_num_atc_unit_num: 'Tỷ lệ sản phẩm đặt đơn / SP bỏ giỏ',
    products_overview_report: 'Báo cáo dữ liệu tổng quan của sản phẩm',
    shop_overview_report: 'Báo cáo dữ liệu tổng quan của shop',
    customer_insights_of_products: 'Phân Tích Insight Khách Hàng Theo Sản phẩm',
    customer_insights_of_all_products: 'Phân Tích Insight Khách Hàng Toàn Shop',
    select_product_to_analyze: 'Chọn sản phẩm để phân tích',
    shop_in_sync_orders_process: 'Cửa hàng đang trong quá trình cập nhật dữ liệu đơn hàng',
    select_shop_to_use_feature: 'Chọn shop để sử dụng tính năng',
    shop_need_to_link: 'Cửa hàng cần được liên kết để sử dụng tính năng này',
    link_account: 'Liên kết tài khoản',
    analyzing_data: 'Đang phân tích dữ liệu',
    order_number: 'Số đơn', // orders
    retail_gmv: 'GMV bán lẻ',
    bundled_gmv: 'GMV bán cùng SP khác',
    since_begin_year: 'Từ đầu năm',
    since_begin_month: 'Từ đầu tháng',
    only_in_year: 'Chỉ trong năm',
    only_in_month: 'Chỉ trong tháng',
    up_to_now: 'Từ trước đến nay',
    from_month_to_month: 'Từ tháng đến tháng',
    top_5_add_on_products_with_highest_gmv: 'TOP 5 SẢN PHẢM MUA KÈM CÓ DOANH THU CAO NHẤT',
    top_5_add_on_products_with_most_buyers: 'TOP 5 SẢN PHẨM MUA KÈM CÓ SỐ NGƯỜI MUA NHIỀU NHẤT',
    top_5_city_with_highest_gmv: 'TOP 5 TỈNH THÀNH CÓ DOANH THU CAO NHẤT',
    top_5_city_with_most_buyers: 'TOP 5 TỈNH THÀNH CÓ SỐ NGƯỜI MUA NHIỀU NHẤT',
    province_city: 'Tỉnh / Thành phố',
    buyer: 'Số người mua',
    items_sold_order: 'Lượt bán TB / đơn',
    return_buyers: 'Số người mua quay lại',
    highest_purchase_time: 'Thời gian mua hàng nhiều nhất',
    city_with_most_buyers: 'Tỉnh thành mua nhiều nhất',
    list_of_add_on_products: 'DANH SÁCH CÁC SẢN PHẨM MUA KÈM',
    purchased_number: 'Số lần mua cùng',
    shopee_master: 'QUÂN SƯ SHOPEE',
    competitive_products: 'SẢN PHẨM CẠNH TRANH',
    shop_analysis_by_city: 'PHÂN TÍCH SỐ ĐƠN, DOANH THU, SỐ NGƯỜI MUA THEO TỈNH',
    shop_analysis_by_period: 'PHÂN TÍCH SỐ ĐƠN, DOANH THU, SỐ NGƯỜI MUA THEO THỜI GIAN',
    add_to_cart_units_30_days: 'Lượt bỏ giỏ (30 ngày qua)',
    add_to_cart_buyers_30_days: 'Số khách bỏ giỏ (30 ngày qua)',
    items_sold_30_days: 'Lượt bán (30 ngày qua)',
    sales_30_days: 'Doanh thu (30 ngày qua)',
    add_to_cart_rate_on_user_view: '% bỏ giỏ / số khách truy cập',
    canceled: 'Số đơn hủy',
    canceled_sales: 'Doanh thu đơn hủy',
    to_return: 'Số đơn hoàn',
    to_return_sales: 'Doanh thu đơn hoàn',
    placed: 'Số đơn đã đặt',
    placed_sales: 'Doanh thu đơn đã đặt',
  }, // todo: end center

  flash_sale: {
    create_new_by_multiple_time_slot: 'Tạo Flash Sale Theo Nhiều Khung Giờ',
    detail: 'Chi Tiết Chương Trình Flash Sale của Shop',
    loading: 'Đang tải danh sách Flase Sale',
    create_new: 'Tạo chương trình Flash Sale mới',
    title: 'Flash Sale Của Shop',
    saved_file: 'File flash sale đã lưu',
    advanced_saved_file: 'File flash sale nâng cao',
    mass_resume: 'Bật chương trình flash sale hàng loạt',
    mass_pause: 'Tắt chương trình flash sale hàng loạt',
    mass_delete: 'Xóa chương trình flash sale hàng loạt',
    enabled_for: 'Bật Flash Sale',
    total_available: 'Số sản phẩm tham gia',
    no_of_reminders_set: 'Lượt đặt Nhắc nhở',
    no_of_product_clicks: 'Lượt nhấp chuột/xem',
    enable_disable: 'Bật/Tắt',
    delete: 'Xóa dữ liệu',
    create_file: 'Tạo file Flash Sale',
    edit_products: 'Cập nhật thông tin sản phẩm',
    enable_auto_config: 'Bật cấu hình tự động',
    disable_auto_config: 'Tạm dừng cấu hình tự động',
    search_placeholder: 'Tìm kiếm theo tên file, product id, sku...',
    auto_config_message: 'Đang chạy tự động. Khung giờ tạo:',
    auto_config_message_x: 'Đang chạy tự động {x}. Khung giờ tạo:',
    auto_config_message_2: 'Đang chạy tự động',
    no_of_product: 'Số sản phẩm',
    setup_auto_config: 'Cấu hình tạo Flash Sale tự động',
    random_message: 'Hệ thống sẽ chọn random các sản phẩm trong tệp và tạo trên toàn bộ khung giờ Flash sale.',
    select_time_slot: 'Chọn khung giờ Flash Sale của shop',
    day: 'Ngày',
    time_slots_selected: 'Số khung giờ đã chọn',
    confirm_selected: 'Xác nhận khung giờ',
    update_file: 'Cập nhật file Flash Sale',
    setup_products_note: 'Cài đặt % Discount và % Số sản phẩm trong kho để chạy tự động tạo Flash sale',
    system_will_create_before_x_hours: 'Hệ thống sẽ tự động tạo Chương trình Flash sale trước {x} tiếng',
    create_before_x_hours: 'Tạo dữ liệu trước {x} tiếng, (tối thiểu {min} tiếng, tối đa {max} tiếng)',
    creation_time_slot: 'Khung giờ tạo Flash Sale',
    show_not_created_only: 'Chỉ hiển thị những sản phẩm chưa được tạo Flash sale',
    filename: 'Tên file Flash Sale',
    save_file: 'Lưu file Flash Sale',
    copy_time_slot: 'Sao chép khung giờ Flash sale',
    select_time_slot_manually: 'Chọn khung giờ thủ công',
    select_time_slot_auto: 'Tự động chọn các khung giờ tương ứng',
    setup_advanced_configuration: 'Thiết lập cấu hình Flash sale tự động nâng cao',
    all_day: 'Chọn cả ngày',
    half_a_day_from: 'Chạy nửa ngày từ',
    custom_time: 'Thời gian tùy chỉnh',
    download_template_file: 'Tải file mẫu',
    download_products_file: 'Tải file sản phẩm',
    import_products: 'Import sản phẩm',
    drag_and_drop_or: 'Kéo file vào đây hoặc',
    click_to_upload: 'click để upload',
    file_format_required: 'Yêu cầu định dạng *.xlsx/*.xls',
    excel_code_title: 'Câu lệnh excel để tính giá bán khuyến mãi bằng 80% giá gốc hoặc giá khuyến mãi hiện tại của sản phẩm',
    excel_code: '=INT([Cột giá bán gốc | Cột giá đang bán] * 80%)',
    excel_code_title_2: 'Câu lệnh excel để lấy 10% số lượng tồn kho của sản phẩm để chạy flash sale',
    excel_code_2: '=INT([Cột tồn kho] * 10%)',
    variations_uploaded: 'phân loại sản phẩm được tải lên thành công',
    add_products_to_file: 'Thêm sản phẩm vào file',
    update_products_confirm: 'Bạn có chắc chắn muốn cập nhật danh sách sản phẩm không?',
    change_config_status_confirm: 'Bạn có chắc chắn muốn thay đổi trạng thái của các cấu hình tự động đang chọn không?',
    invalid_discount_price: 'Giá khuyến mãi flash sale không hợp lệ',
    invalid_quantity: 'Số lượng sản phẩm khuyến mãi không hợp lệ',
    enable_time_slots_confirm: 'Bạn có chắc chắn muốn bật toàn bộ chươn trình flash sale đã chọn không?',
    disable_time_slots_confirm: 'Tắt chương trình này nghĩa là bạn đồng ý loại bỏ tất cả các sản phẩm đã đăng ký Flash Sale của Shop. Nếu muốn chuyển trạng thái chương trình sang "Bật" lại, bạn phải đăng ký lại từng sản phẩm cho chương trình.',
    delete_confirm: 'Bạn có chắc chắn muốn xóa chương trình flash sale đã chọn không?',
    mass_delete_confirm: 'Bạn có chắc chắn muốn xóa toàn bộ chương trình flash sale đã chọn không?',
    delete_file_confirm: 'Bạn có muốn xóa file sản phẩm Flash sale này không?',
    delete_files_confirm: 'Bạn có muốn xóa các file sản phẩm Flash sale này không?',
    save_products_to_file: 'Lưu sản phẩm vào file',
    promotion_quantity: 'Số lượng khuyến mãi',
    campaign_stock: 'SL sản phẩm khuyến mãi',
    purchase_limit: 'Giới hạn đặt hàng',
    discount: 'Giảm',
    discount_percent_between_x_y: 'Phần trăm giảm phải lớn hơn {x} và nhỏ hơn {y}',
    promotion_quantity_between_x_y: 'Số lượng khuyến mãi phải lớn hơn {x} và nhỏ hơn {y}',
    promotion_quantity_lt_x: 'Số lượng khuyến mãi phải nhỏ hơn {x}',
    evenly_every_days: 'Tổng số lượng sản phẩm khuyến mãi phải chia đều cho các ngày.',
    api_error_response: 'Rất tiếc, sản phẩm này chưa đạt đủ điều kiện. Vui lòng tham khảo trang thông tin về quy định tham gia chương trình Flash Sale của Shop.<br/>Mã lỗi',
    updated_message: 'Đã cập nhật thông tin sản phẩm',
    create_title: 'Tổng số sản phẩm đang có sẵn',
    you_have_enabled: 'Bạn đã chọn',
    products_for_selected_time_slots: 'sản phẩm cho những khung giờ đã chọn',
    back_to_list_message: 'Hãy thêm và kích hoạt từng sản phẩm trong mục Flash Sale của Shop.',
    discount_percent_is_higher_x: 'Phần trăm giảm giá đang cao hơn {x}',
    discount_percent_is_higher_x_warning: 'Trong danh sách sản phẩm tạo Flash sale có khuyến mãi phân loại cao hơn {x}, điều này sẽ làm ảnh hưởng tới doanh thu bán hàng. Bạn có muốn tiếp tục tạo không?',
    attention_when_create: '<br/>Cảnh báo phân loại khi tạo flash sale.<br/>Mã lỗi',
    live_period: 'Thời gian Flash Sale diễn ra',
    create_error_message: 'Đã có lỗi xảy ra khi tạo chương trình Flash sale',
    set_by_percent: 'Cài theo phần trăm',
    set_by_amount: 'Cài theo số tiền',
    reduce_by_amount: 'Giảm theo số tiền',
    runtime: 'Thời gian chạy',
    exclude_spike_day: 'Ngoại trừ ngày Flash Sale, Mini Sale',
    includes_mini_spike_day: 'Bao gồm ngày Mini Sale',
    using_original_price: 'Đang sử dụng giá bán gốc',
    using_discount_price: 'Đang sử dụng giá khuyến mãi',
    use_original_price: 'Sử dụng giá bán gốc',
    use_discount_price: 'Sử dụng giá khuyến mãi',
    change_product_position: 'Thay đổi vị trí sản phẩm',
    misleading_message: 'Việc này có thể vi phạm Quy định Giá ảo',
    this_may_violate: 'Việc này có thể vi phạm',
    misleading_policy: 'Quy định Giá ảo',
    has_a_product_met_misleading_policy: 'Có ít nhất 1 phân loại vi phạm quy định giá ảo. Bạn có muốn tiếp tục tạo không?',
  }, // todo: end flash_sale

  main: {
    change_to_app_message: 'Hiện tại tính năng đã được chuyển xuống phiên bản Atosa dành cho máy tính. Quý khách vui lòng tải App để sử dụng tinh năng!',
  }, // todo: end main,

  voucher: {
    title: 'Mã Giảm Giá Của Shop',
    create: 'Tạo mã giảm giá',
    create_multiple: 'Tạo nhiều mã giảm giá',
    saved_files: 'File voucher đã lưu',
    search_placeholder: 'Nhập mã, tên, loại voucher',
    name: 'Tên mã',
    type: 'Loại mã',
    auto_config: 'Cài đặt tự động',
    no_of: 'Tổng số mã giảm giá',
    saved_quantity: 'Đã lưu',
    usage_quantity: 'Đã dùng',
    claiming_period: 'Thời gian sử dụng mã',
    create_title: 'Tạo Mã giảm giá mới',
    create_multiple_title: 'Tạo nhiều mã giảm giá',
    filename: 'Tên file voucher',
    auto_create_by_time_slots_daily: 'Tạo voucher hàng ngày theo khung giờ',
    allow_repeat_monthly: 'Cho phép chạy lặp lại hàng tháng',
    create_hour: 'Giờ tạo mã giảm giá', // quantity_of_each_time_slot: 'Số lượng mã mỗi khung giờ',
    quantity_of_each_time_slot: 'Số lượng mã giảm giá',
    auto_time_slot_list: 'Danh sách khung giờ tạo voucher tự động',
    create_at: 'Sẽ tạo lúc',
    create_time_slots: 'Khung giờ tạo mã',
    vouchers: 'mã',
    auto_create_monthly: 'Tạo voucher hàng tháng',
    auto_create_weekly: 'Tạo voucher hàng tuần',
    shop_voucher: 'Mã giảm giá toàn Shop',
    product_voucher: 'Mã giảm giá trên sản phẩm',
    private_voucher: 'Voucher riêng tư',
    stop_confirm: 'Bạn có chắc chắn muốn dừng Mã giảm giá này không?',
    delete_confirm: 'Bạn có chắc chắn muốn xoá Mã giảm giá này không?',
    voucher_name: 'Tên chương trình mã giảm giá',
    visible_to_buyers: 'Tên mã giảm không hiển thị với người mua',
    code: 'Mã voucher',
    gen_code_auto: 'Tạo mã tự động',
    gen_code: 'Tạo mã voucher',
    please_enter: 'Vui lòng chỉ nhập các kí tự chữ cái (A-Z), số (0-9); tối đa 5 kí tự.',
    complete_code_is: 'Mã giảm giá đầy đủ là',
    usage_period: 'Thời gian sử dụng mã',
    reward_settings: 'Thiết lập mã giảm giá',
    select_settings_template: 'Chọn mẫu cấu hình',
    reward_type: 'Loại voucher',
    coin_cashback: 'Hoàn xu',
    discount_type: 'Loại giảm giá',
    amount: 'Mức giảm',
    by_percent: 'Theo phần trăm',
    by_amount: 'Theo số tiền',
    will_be_returned_message: 'Người mua sẽ nhận được {x}% từ số tiền thanh toán bằng Shopee xu',
    min_basket_price: 'Giá trị đơn hàng tối thiểu',
    max_capped_amount: 'Mức giảm giá tối đa',
    equals_to: 'Tương đương',
    coin: 'Xu',
    coins: 'Xu',
    max_usage_quantity: 'Lượt sử dụng tối đa',
    max_distribution: 'Lượt sử dụng tối đa / Người mua',
    save_settings_template: 'Lưu mẫu cấu hình',
    voucher_display_title: 'Hiển thị mã giảm và các sản phẩm áp dụng',
    display_on_all_pages: 'Hiển thị nhiều nơi',
    display_setting: 'Thiết lập hiển thị',
    shared_through_code: 'Chia sẻ thông qua mã voucher',
    applicable_products: 'Sản phẩm được áp dụng',
    show_selected_products: 'Xem sản phẩm đã chọn',
    update: 'Cập nhật mã giảm giá',
    confirm_and_create: 'Xác nhận và tạo mã',
    confirm_and_save_file: 'Xác nhận và lưu file',
    settings_template: 'Mẫu voucher khuyến mãi',
    template_name: 'Tên mẫu',
    template_name_1: 'Giảm 500K, đơn từ 0 đồng, số lượng 1',
    template_name_2: 'Giảm 200K, đơn từ 0 đồng, số lượng 3',
    template_name_3: 'Giảm 100K, đơn từ 0 đồng, số lượng 5',
    template_name_4: 'Giảm 50K, đơn từ 0 đồng, số lượng 10',
    template_name_5: 'Giảm 5%, đơn từ 100K, tối đa 15K, số lượng không giới hạn',
    template_name_6: 'Giảm 25%, đơn từ 150K, tối đa 25K, số lượng không giới hạn',
    custom: 'Tự điều chỉnh',
    at_least_1_day: 'Chương trình kéo dài ít nhất 1 ngày kể từ khi bắt đầu',
    discount_gt_min: 'Mức giảm giá không được vượt quá giá trị đơn hàng tối thiểu',
    required_max_capped_amount: 'Vui lòng nhập mức giảm tối đa',
    required_coin_cashback: 'Vui lòng nhập mức % hoàn xu',
    required_max_coin_cashback: 'Vui lòng nhập mức hoàn xu tối đa',
    required_usage_quantity: 'Lượt sử dụng tối đa không được để trống',
    create_success: 'Tạo Mã giảm giá thành công',
    error_message: 'Đã có lỗi xảy ra khi tạo Mã giảm giá. Mã lỗi',
    already_exist_message: 'Mã voucher đã được sử dụng',
    param_error_message: 'Tham số không hợp lệ',
    create_auto_by_atosa: 'Mã giảm giá sẽ được tạo tự động bởi Atosa',
    new_buyer_voucher: 'Voucher Khách hàng mới',
    repeat_buyer_voucher: 'Voucher Khách hàng mua lại',
    follow_prize_voucher: 'Ưu đãi Follower',
    target_buyer: 'Người mua mục tiêu',
    new_buyer_voucher_description: 'Khách hàng chưa từng mua sắm tại Shop.',
    purchased: 'Đã mua hàng',
    purchased_times: 'lần tại Shop trong',
    purchased_days: 'ngày gần nhất.',
  }, // todo: end voucher

  tool: {
    analysis_note: 'Dữ liệu phân tích dựa trên những thông tin được hiển thị tại trang sản phẩm của Shop',
    input_link: 'Nhập link shop, VD: https://shopee.vn/ten_shop',
    monthly_sold: 'Đã bán trong tháng',
    aov: 'Giá trị trung bình đơn',
    monthly_sales: 'Doanh thu tháng',
    monthly_aov: 'Giá trị trung bình đơn tháng',
    show_variations: 'Xem phân loại',
    download_app_title: 'Tính năng sẽ hoạt động tốt hơn khi chạy ở dưới App Atosa. Quý khách có thể tải app để tăng hiệu năng sử dụng.',
    download_app_message: 'Để thuận tiện cho việc sử dụng tính năng Nghiên cứu thị trường, Quý Khách vui lòng tải và cài đặt ứng dụng Atosa trên máy tính.',
    download_app: 'Tải App Atosa',
    day_number_creation: 'Số ngày đăng',
    manual_save: 'Lưu thủ công',
    auto_save: 'Lưu tự động',
    save_type: 'Kiểu lưu',
    cannot_get_data: 'Không thể lấy dữ liệu. Vui lòng đăng nhập tài khoản shopee hoặc kiểm tra lại trình duyệt ảo.',
    invalid_shop_url: 'Link shop không hợp lệ',
    buy_package_message: 'Vui lòng mua gói Nghiên cứu thì trường hoặc Phân tích đối thủ để sử dụng tính năng này',
    limit_package_message: 'Quý khách đã sử dụng tối đa số lượt tìm kiếm trong tháng. Vui lòng mua gói Nghiên cứu thì trường hoặc Phân tích đối thủ để sử dụng tính năng này',
    analyze_success: 'Phân tích thông tin thành công',
    shopee_trend: 'Công cụ Shopee Trend',
    click_to_stop: 'Ấn để dừng',
    input_keyword: 'Nhập từ khóa để theo dõi',
    added_keywords: 'Số từ khóa đã thêm',
    shopee_trend_data: 'Dữ liệu Shopee Trend',
    max_products: 'Số lượng sản phẩm tối đa',
    relevance: 'Phổ biến',
    latest: 'Mới nhất',
    top_sales: 'Bán chạy',
    price_range: 'Khoảng giá',
    min: 'Từ',
    max: 'Đến',
    show_seo_products_only: 'Chỉ hiển thị sản phẩm SEO',
    category: 'Danh mục',
    category_level: 'Danh mục cấp',
    exclude_buff_products: 'Lọc sản phẩm buff đơn',
    remove_exclude_buff_products: 'Bỏ lọc sản phẩm buff đơn',
    comments_sold_rate: 'Tỉ lệ Comment/Đã bán',
    comments: 'Lượt comment',
    ads_products: 'Danh sách sản phẩm quảng cáo',
    limit_x_message: 'Lưu ý: Atosa sẽ chỉ hiển thị tối đa {x} sản phẩm quảng cáo',
    reviews: 'Số lượt review',
    buys: 'Lượt mua',
    ads_type: 'Kiểu chạy Ads',
  }, // todo: end tool
}
// end json



// WEBPACK FOOTER //
// ./src/i18n/locales/vi.js